// // File Location: src/pages/application/ApplicationDetails.jsx

// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// NOTE: Legacy, commented-out implementation removed for clarity. Stray top-level hook usage deleted to satisfy React Hooks rules.

//           <div>
//             <label className="text-sm font-medium text-gray-500">Age & Gender</label>
//             <p className="text-gray-900">{application.patient?.age} years, {application.patient?.gender}</p>
//           </div>

//           <div>
//             <label className="text-sm font-medium text-gray-500">Contact</label>
//             <div className="space-y-1">
//               <div className="flex items-center space-x-2">
//                 <Phone className="h-3 w-3 text-gray-400" />
//                 <p className="text-sm text-gray-900">{application.patient?.phone}</p>
//               </div>
//               {application.patient?.email && (
//                 <div className="flex items-center space-x-2">
//                   <Mail className="h-3 w-3 text-gray-400" />
//                   <p className="text-sm text-gray-900">{application.patient?.email}</p>
//                 </div>
//               )}
//             </div>
//           </div>

//           <div>
//             <label className="text-sm font-medium text-gray-500">Aadhar Number</label>
//             <p className="text-gray-900 font-mono">****-****-{application.patient?.kyc?.aadharNumber?.slice(-4)}</p>
//           </div>

//           <div>
//             <label className="text-sm font-medium text-gray-500">Address</label>
//             <div className="flex items-start space-x-2">
//               <MapPin className="h-3 w-3 text-gray-400 mt-1" />
//               <p className="text-sm text-gray-900">{application.patient?.address}</p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Medical Information */}
//       <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//         <div className="flex items-center space-x-3 mb-6">
//           <div className="bg-blue-100 p-2 rounded-lg">
//             <Stethoscope className="h-5 w-5 text-blue-600" />
//           </div>
//           <h2 className="text-xl font-semibold text-gray-900">Medical Information</h2>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//           <div className="space-y-4">
//             <div>
//               <label className="text-sm font-medium text-gray-500">Diagnosis</label>
//               <p className="text-gray-900 font-medium">{application.medical?.diagnosis}</p>
//             </div>

//             <div>
//               <label className="text-sm font-medium text-gray-500">Treatment Type</label>
//               <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
//                 application.medical?.treatmentType === 'surgical' 
//                   ? 'bg-red-100 text-red-800' 
//                   : 'bg-blue-100 text-blue-800'
//               }`}>
//                 {application.medical?.treatmentType?.charAt(0).toUpperCase() + application.medical?.treatmentType?.slice(1)}
//               </span>
//             </div>

//             <div>
//               <label className="text-sm font-medium text-gray-500">Consulting Doctor</label>
//               <p className="text-gray-900">{application.medical?.doctor?.name}</p>
//               <p className="text-sm text-gray-600">{application.medical?.doctor?.designation}</p>
//             </div>

//             <div>
//               <label className="text-sm font-medium text-gray-500">Procedure Details</label>
//               <p className="text-gray-900">{application.medical?.procedureDetails}</p>
//             </div>
//           </div>

//           <div className="space-y-4">
//             <div className="grid grid-cols-2 gap-4">
//               <div>
//                 <label className="text-sm font-medium text-gray-500">Admission Date</label>
//                 <div className="flex items-center space-x-2">
//                   <Calendar className="h-3 w-3 text-gray-400" />
//                   <p className="text-sm text-gray-900">{application.medical?.admissionDate}</p>
//                 </div>
//               </div>

//               <div>
//                 <label className="text-sm font-medium text-gray-500">Discharge Date</label>
//                 <div className="flex items-center space-x-2">
//                   <Calendar className="h-3 w-3 text-gray-400" />
//                   <p className="text-sm text-gray-900">{application.medical?.dischargeDate || 'TBD'}</p>
//                 </div>
//               </div>
//             </div>

//             <div className="grid grid-cols-2 gap-4">
//               <div>
//                 <label className="text-sm font-medium text-gray-500">Estimated Cost</label>
//                 <p className="text-lg font-semibold text-gray-900">₹{application.medical?.estimatedCost?.toLocaleString('en-IN')}</p>
//               </div>

//               <div>
//                 <label className="text-sm font-medium text-gray-500">Actual Cost</label>
//                 <p className="text-lg font-semibold text-gray-900">
//                   {application.medical?.actualCost 
//                     ? `₹${application.medical.actualCost.toLocaleString('en-IN')}`
//                     : 'TBD'
//                   }
//                 </p>
//               </div>
//             </div>

//             {application.medical?.treatments && application.medical.treatments.length > 0 && (
//               <div>
//                 <label className="text-sm font-medium text-gray-500 mb-2 block">Treatment History</label>
//                 <div className="space-y-2">
//                   {application.medical.treatments.map((treatment, index) => (
//                     <div key={index} className="bg-gray-50 rounded-lg p-3">
//                       <div className="flex justify-between items-start">
//                         <div>
//                           <p className="font-medium text-gray-900">{treatment.treatmentName}</p>
//                           <p className="text-sm text-gray-600">{treatment.description}</p>
//                         </div>
//                         <div className="text-right">
//                           <p className="text-sm font-medium text-gray-900">₹{treatment.cost?.toLocaleString('en-IN')}</p>
//                           <p className="text-xs text-gray-500">{treatment.date}</p>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Policy Information */}
//       <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//         <div className="flex items-center space-x-3 mb-6">
//           <div className="bg-green-100 p-2 rounded-lg">
//             <Shield className="h-5 w-5 text-green-600" />
//           </div>
//           <h2 className="text-xl font-semibold text-gray-900">Insurance Policy</h2>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           <div>
//             <label className="text-sm font-medium text-gray-500">Policy Number</label>
//             <p className="text-gray-900 font-mono">{application.policy?.number}</p>
//           </div>

//           <div>
//             <label className="text-sm font-medium text-gray-500">Insurance Company</label>
//             <p className="text-gray-900">{application.policy?.insuranceCompany}</p>
//           </div>

//           <div>
//             <label className="text-sm font-medium text-gray-500">Policy Type</label>
//             <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
//               application.policy?.type === 'corporate' 
//                 ? 'bg-purple-100 text-purple-800' 
//                 : 'bg-blue-100 text-blue-800'
//             }`}>
//               {application.policy?.type?.charAt(0).toUpperCase() + application.policy?.type?.slice(1)}
//             </span>
//           </div>

//           <div>
//             <label className="text-sm font-medium text-gray-500">Coverage Amount</label>
//             <p className="text-lg font-semibold text-gray-900">₹{application.policy?.coverageAmount?.toLocaleString('en-IN')}</p>
//           </div>

//           <div>
//             <label className="text-sm font-medium text-gray-500">Policy Period</label>
//             <p className="text-gray-900">{application.policy?.startDate} to {application.policy?.endDate}</p>
//           </div>

//           {application.policy?.tpaName && (
//             <div>
//               <label className="text-sm font-medium text-gray-500">TPA</label>
//               <p className="text-gray-900">{application.policy.tpaName}</p>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Policy Holder Information */}
//       {application.policyHolder && !application.policyHolder.isSelf && (
//         <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//           <div className="flex items-center space-x-3 mb-6">
//             <div className="bg-purple-100 p-2 rounded-lg">
//               <User className="h-5 w-5 text-purple-600" />
//             </div>
//             <h2 className="text-xl font-semibold text-gray-900">Policy Holder Information</h2>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             <div>
//               <label className="text-sm font-medium text-gray-500">Policy Holder Name</label>
//               <p className="text-gray-900">{application.policyHolder.name}</p>
//             </div>

//             <div>
//               <label className="text-sm font-medium text-gray-500">Age & Gender</label>
//               <p className="text-gray-900">{application.policyHolder.age} years, {application.policyHolder.gender}</p>
//             </div>

//             <div>
//               <label className="text-sm font-medium text-gray-500">Relationship</label>
//               <p className="text-gray-900">{application.policyHolder.relationshipWithPatient}</p>
//             </div>

//             <div>
//               <label className="text-sm font-medium text-gray-500">Contact</label>
//               <p className="text-gray-900">{application.policyHolder.phone}</p>
//             </div>

//             <div>
//               <label className="text-sm font-medium text-gray-500">Nominee</label>
//               <p className="text-gray-900">{application.policyHolder.nominee?.name}</p>
//               <p className="text-sm text-gray-600">{application.policyHolder.nominee?.relationshipWithNominee}</p>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );

//   const renderDocuments = () => (
//     <div className="space-y-6">
//       <div className="flex items-center justify-between">
//         <h2 className="text-xl font-semibold text-gray-900">Application Documents</h2>
//         <div className="text-sm text-gray-600">
//           {Object.keys(application.documents || {}).length} document(s) uploaded
//         </div>
//       </div>

//       {application.documents && Object.keys(application.documents).length > 0 ? (
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//           {Object.entries(application.documents).map(([key, doc]) => (
//             <div key={key} className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
//               <div className="flex items-start justify-between mb-3">
//                 <div className="flex items-center space-x-2">
//                   <FileText className="h-5 w-5 text-blue-500" />
//                   <h4 className="font-medium text-gray-900 text-sm">
//                     {key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
//                   </h4>
//                 </div>
//                 <div className="flex items-center space-x-1">
//                   <button
//                     onClick={() => openDocument(doc)}
//                     className="text-blue-600 hover:text-blue-800 p-1"
//                     title="View Document"
//                   >
//                     <Eye className="h-4 w-4" />
//                   </button>
//                   <button
//                     onClick={() => {
//                       const link = document.createElement('a');
//                       link.href = doc.url;
//                       link.download = doc.fileName;
//                       link.click();
//                     }}
//                     className="text-green-600 hover:text-green-800 p-1"
//                     title="Download Document"
//                   >
//                     <Download className="h-4 w-4" />
//                   </button>
//                 </div>
//               </div>

//               <div className="text-sm text-gray-600 space-y-1">
//                 <p className="truncate">{doc.fileName}</p>
//                 <p>Size: {(doc.size / 1024).toFixed(1)} KB</p>
//                 <p>Uploaded: {formatDate(doc.uploadedAt)}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       ) : (
//         <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
//           <FileText className="h-12 w-12 text-gray-400 mx-auto mb-4" />
//           <h3 className="text-lg font-medium text-gray-900 mb-2">No Documents</h3>
//           <p className="text-gray-600">No documents have been uploaded for this application.</p>
//         </div>
//       )}
//     </div>
//   );

//   const renderStatusTimeline = () => {
//     const statusHistory = [
//       {
//         status: 'submitted',
//         title: 'Application Submitted',
//         description: 'Hospital submitted the patient application',
//         timestamp: application.submittedAt,
//         completed: true,
//         icon: FileText,
//         color: 'blue'
//       },
//       {
//         status: 'medical_review',
//         title: 'Medical Review',
//         description: 'Medical team reviewing patient documents',
//         timestamp: application.workflow?.medicalVerification?.verifiedAt,
//         completed: application.workflow?.medicalVerification?.status === 'approved',
//         icon: Stethoscope,
//         color: 'green'
//       },
//       {
//         status: 'policy_review',
//         title: 'Policy Verification',
//         description: 'Policy team verifying insurance details',
//         timestamp: application.workflow?.policyVerification?.verifiedAt,
//         completed: application.workflow?.policyVerification?.status === 'approved',
//         icon: Shield,
//         color: 'purple'
//       },
//       {
//         status: 'kyc_verification',
//         title: 'KYC Verification',
//         description: 'Patient identity and documents verification',
//         timestamp: application.workflow?.kycVerification?.verifiedAt,
//         completed: application.workflow?.kycVerification?.status === 'approved',
//         icon: User,
//         color: 'orange'
//       },
//       {
//         status: 'approved',
//         title: 'Application Approved',
//         description: 'Application approved for processing',
//         timestamp: application.approvedAt,
//         completed: application.status === 'approved',
//         icon: CheckCircle,
//         color: 'green'
//       }
//     ];

//     return (
//       <div className="space-y-6">
//         <div className="flex items-center justify-between">
//           <h2 className="text-xl font-semibold text-gray-900">Application Status Timeline</h2>
//           <span className={`px-3 py-1 rounded-full text-sm font-medium border ${getStatusColor(application.status)}`}>
//             {application.status?.replace('_', ' ').charAt(0).toUpperCase() + application.status?.replace('_', ' ').slice(1)}
//           </span>
//         </div>

//         <div className="bg-white rounded-lg border border-gray-200 p-6">
//           <div className="space-y-6">
//             {statusHistory.map((item, index) => {
//               const Icon = item.icon;
//               const isActive = index === statusHistory.findIndex(s => !s.completed);
//               const isCompleted = item.completed;

//               return (
//                 <div key={item.status} className="relative">
//                   {index < statusHistory.length - 1 && (
//                     <div className={`absolute left-4 top-8 w-0.5 h-12 ${
//                       isCompleted ? 'bg-green-300' : 'bg-gray-200'
//                     }`} />
//                   )}

//                   <div className="flex items-start space-x-4">
//                     <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${
//                       isCompleted 
//                         ? 'bg-green-100 border-green-500' 
//                         : isActive 
//                         ? 'bg-yellow-100 border-yellow-500' 
//                         : 'bg-gray-100 border-gray-300'
//                     }`}>
//                       <Icon className={`h-4 w-4 ${
//                         isCompleted 
//                           ? 'text-green-600' 
//                           : isActive 
//                           ? 'text-yellow-600' 
//                           : 'text-gray-400'
//                       }`} />
//                     </div>

//                     <div className="flex-1">
//                       <div className="flex items-center justify-between">
//                         <h3 className={`font-medium ${
//                           isCompleted ? 'text-gray-900' : isActive ? 'text-gray-900' : 'text-gray-500'
//                         }`}>
//                           {item.title}
//                         </h3>
//                         {item.timestamp && (
//                           <span className="text-sm text-gray-500">
//                             {formatDate(item.timestamp)}
//                           </span>
//                         )}
//                       </div>
//                       <p className={`text-sm ${
//                         isCompleted ? 'text-gray-600' : isActive ? 'text-gray-600' : 'text-gray-400'
//                       }`}>
//                         {item.description}
//                       </p>

//                       {/* Workflow comments */}
//                       {item.status === 'medical_review' && application.workflow?.medicalVerification?.comments && (
//                         <div className="mt-2 p-2 bg-green-50 rounded border border-green-200">
//                           <p className="text-sm text-green-800">{application.workflow.medicalVerification.comments}</p>
//                         </div>
//                       )}

//                       {item.status === 'policy_review' && application.workflow?.policyVerification?.comments && (
//                         <div className="mt-2 p-2 bg-purple-50 rounded border border-purple-200">
//                           <p className="text-sm text-purple-800">{application.workflow.policyVerification.comments}</p>
//                         </div>
//                       )}

//                       {item.status === 'kyc_verification' && application.workflow?.kycVerification?.comments && (
//                         <div className="mt-2 p-2 bg-orange-50 rounded border border-orange-200">
//                           <p className="text-sm text-orange-800">{application.workflow.kycVerification.comments}</p>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>

//         {/* Current Status Details */}
//         <div className="bg-white rounded-lg border border-gray-200 p-6">
//           <h3 className="text-lg font-semibold text-gray-900 mb-4">Current Status Details</h3>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//             <div className="text-center">
//               <div className={`inline-flex p-3 rounded-full mb-2 ${
//                 application.workflow?.medicalVerification?.status === 'approved' 
//                   ? 'bg-green-100' 
//                   : application.workflow?.medicalVerification?.status === 'rejected'
//                   ? 'bg-red-100'
//                   : 'bg-yellow-100'
//               }`}>
//                 <Stethoscope className={`h-6 w-6 ${
//                   application.workflow?.medicalVerification?.status === 'approved' 
//                     ? 'text-green-600' 
//                     : application.workflow?.medicalVerification?.status === 'rejected'
//                     ? 'text-red-600'
//                     : 'text-yellow-600'
//                 }`} />
//               </div>
//               <h4 className="font-medium text-gray-900">Medical Review</h4>
//               <p className="text-sm text-gray-600">
//                 {application.workflow?.medicalVerification?.status === 'approved' 
//                   ? 'Approved' 
//                   : application.workflow?.medicalVerification?.status === 'rejected'
//                   ? 'Rejected'
//                   : 'Pending Review'}
//               </p>
//             </div>

//             <div className="text-center">
//               <div className={`inline-flex p-3 rounded-full mb-2 ${
//                 application.workflow?.policyVerification?.status === 'approved' 
//                   ? 'bg-green-100' 
//                   : application.workflow?.policyVerification?.status === 'rejected'
//                   ? 'bg-red-100'
//                   : 'bg-yellow-100'
//               }`}>
//                 <Shield className={`h-6 w-6 ${
//                   application.workflow?.policyVerification?.status === 'approved' 
//                     ? 'text-green-600' 
//                     : application.workflow?.policyVerification?.status === 'rejected'
//                     ? 'text-red-600'
//                     : 'text-yellow-600'
//                 }`} />
//               </div>
//               <h4 className="font-medium text-gray-900">Policy Review</h4>
//               <p className="text-sm text-gray-600">
//                 {application.workflow?.policyVerification?.status === 'approved' 
//                   ? 'Approved' 
//                   : application.workflow?.policyVerification?.status === 'rejected'
//                   ? 'Rejected'
//                   : 'Pending Review'}
//               </p>
//             </div>

//             <div className="text-center">
//               <div className={`inline-flex p-3 rounded-full mb-2 ${
//                 application.workflow?.kycVerification?.status === 'approved' 
//                   ? 'bg-green-100' 
//                   : application.workflow?.kycVerification?.status === 'rejected'
//                   ? 'bg-red-100'
//                   : 'bg-yellow-100'
//               }`}>
//                 <User className={`h-6 w-6 ${
//                   application.workflow?.kycVerification?.status === 'approved' 
//                     ? 'text-green-600' 
//                     : application.workflow?.kycVerification?.status === 'rejected'
//                     ? 'text-red-600'
//                     : 'text-yellow-600'
//                 }`} />
//               </div>
//               <h4 className="font-medium text-gray-900">KYC Verification</h4>
//               <p className="text-sm text-gray-600">
//                 {application.workflow?.kycVerification?.status === 'approved' 
//                   ? 'Approved' 
//                   : application.workflow?.kycVerification?.status === 'rejected'
//                   ? 'Rejected'
//                   : 'Pending Review'}
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderSanctions = () => {
//     const availableLetters = [
//       {
//         id: 'kyp',
//         title: 'KYP Letter',
//         description: 'Know Your Patient verification letter',
//         status: application.workflow?.medicalVerification?.status === 'approved' ? 'available' : 'pending',
//         icon: User,
//         color: 'blue'
//       },
//       {
//         id: 'approval',
//         title: 'Final Approval Letter',
//         description: 'Application approval confirmation',
//         status: application.status === 'approved' ? 'available' : 'pending',
//         icon: CheckCircle,
//         color: 'green'
//       },
//       {
//         id: 'disbursal',
//         title: 'Disbursal Letter',
//         description: 'Treatment cost disbursal authorization',
//         status: application.status === 'approved' && application.disbursalLetterGenerated ? 'available' : 'pending',
//         icon: CreditCard,
//         color: 'purple'
//       },
//       {
//         id: 'closure',
//         title: 'Case Closure Letter',
//         description: 'Final case closure and settlement',
//         status: application.status === 'closed' ? 'available' : 'pending',
//         icon: Award,
//         color: 'orange'
//       }
//     ];

//     return (
//       <div className="space-y-6">
//         <div className="flex items-center justify-between">
//           <div>
//             <h2 className="text-xl font-semibold text-gray-900">Sanctions & Letters</h2>
//             <p className="text-sm text-gray-600">Generate and download official letters and documents</p>
//           </div>
//         </div>

//         {/* Available Letters */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           {availableLetters.map((letter) => {
//             const Icon = letter.icon;
//             const isAvailable = letter.status === 'available';
//             const existingLetter = sanctions.find(s => s.type === letter.id);

//             return (
//               <div key={letter.id} className="bg-white border border-gray-200 rounded-lg p-6">
//                 <div className="flex items-start justify-between mb-4">
//                   <div className="flex items-center space-x-3">
//                     <div className={`p-2 rounded-lg ${
//                       isAvailable ? `bg-${letter.color}-100` : 'bg-gray-100'
//                     }`}>
//                       <Icon className={`h-5 w-5 ${
//                         isAvailable ? `text-${letter.color}-600` : 'text-gray-400'
//                       }`} />
//                     </div>
//                     <div>
//                       <h3 className={`font-medium ${isAvailable ? 'text-gray-900' : 'text-gray-500'}`}>
//                         {letter.title}
//                       </h3>
//                       <p className={`text-sm ${isAvailable ? 'text-gray-600' : 'text-gray-400'}`}>
//                         {letter.description}
//                       </p>
//                     </div>
//                   </div>

//                   <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
//                     isAvailable 
//                       ? 'bg-green-100 text-green-800' 
//                       : 'bg-gray-100 text-gray-600'
//                   }`}>
//                     {isAvailable ? 'Available' : 'Pending'}
//                   </span>
//                 </div>

//                 {existingLetter ? (
//                   <div className="space-y-3">
//                     <div className="bg-green-50 border border-green-200 rounded-lg p-3">
//                       <div className="flex items-center justify-between">
//                         <div>
//                           <p className="text-sm font-medium text-green-800">Letter Generated</p>
//                           <p className="text-xs text-green-600">
//                             Generated on {formatDate(existingLetter.generatedAt)}
//                           </p>
//                         </div>
//                         <div className="flex items-center space-x-2">
//                           <button
//                             onClick={() => openLetter(existingLetter)}
//                             className="text-blue-600 hover:text-blue-800 text-sm"
//                           >
//                             <Eye className="h-4 w-4" />
//                           </button>
//                           <button
//                             onClick={() => {
//                               const link = document.createElement('a');
//                               link.href = existingLetter.url;
//                               link.download = existingLetter.fileName;
//                               link.click();
//                             }}
//                             className="text-green-600 hover:text-green-800 text-sm"
//                           >
//                             <Download className="h-4 w-4" />
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ) : isAvailable ? (
//                   <button
//                     onClick={() => generateAndDownloadLetter(letter.id)}
//                     disabled={actionLoading[letter.id]}
//                     className="w-full bg-teal-600 text-white px-4 py-2 rounded-lg hover:bg-teal-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
//                   >
//                     {actionLoading[letter.id] ? (
//                       <>
//                         <Loader className="h-4 w-4 animate-spin" />
//                         <span>Generating...</span>
//                       </>
//                     ) : (
//                       <>
//                         <Download className="h-4 w-4" />
//                         <span>Generate & Download</span>
//                       </>
//                     )}
//                   </button>
//                 ) : (
//                   <div className="text-center py-4">
//                     <p className="text-sm text-gray-500">
//                       {letter.id === 'kyp' ? 'Complete medical review to generate' :
//                        letter.id === 'approval' ? 'Complete all verifications to generate' :
//                        letter.id === 'disbursal' ? 'Application approval required' :
//                        'Case closure required'}
//                     </p>
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>

//         {/* Generated Documents History */}
//         {sanctions.length > 0 && (
//           <div className="bg-white rounded-lg border border-gray-200 p-6">
//             <h3 className="text-lg font-semibold text-gray-900 mb-4">Document History</h3>

//             <div className="space-y-3">
//               {sanctions.map((sanction) => (
//                 <div key={sanction.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
//                   <div className="flex items-center space-x-3">
//                     <FileText className="h-5 w-5 text-gray-600" />
//                     <div>
//                       <p className="font-medium text-gray-900">{sanction.title}</p>
//                       <p className="text-sm text-gray-600">
//                         Generated by {sanction.generatedBy} on {formatDate(sanction.generatedAt)}
//                       </p>
//                     </div>
//                   </div>

//                   <div className="flex items-center space-x-2">
//                     <button
//                       onClick={() => openLetter(sanction)}
//                       className="text-blue-600 hover:text-blue-800"
//                       title="View Letter"
//                     >
//                       <Eye className="h-4 w-4" />
//                     </button>
//                     <button
//                       onClick={() => {
//                         const link = document.createElement('a');
//                         link.href = sanction.url;
//                         link.download = sanction.fileName;
//                         link.click();
//                       }}
//                       className="text-green-600 hover:text-green-800"
//                       title="Download Letter"
//                     >
//                       <Download className="h-4 w-4" />
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   };

//   const renderTabContent = () => {
//     switch (activeTab) {
//       case 'details':
//         return renderApplicationDetails();
//       case 'documents':
//         return renderDocuments();
//       case 'discussions':
//         return (
//           <DiscussionComponent 
//             applicationId={applicationId} 
//             onUnreadCountChange={handleUnreadCountChange}
//           />
//         );
//       case 'status':
//         return renderStatusTimeline();
//       case 'sanctions':
//         return renderSanctions();
//       default:
//         return renderApplicationDetails();
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50">
//       {/* Header */}
//       <div className="bg-white shadow-sm border-b border-gray-200">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between py-4">
//             <div className="flex items-center space-x-4">
//               <button
//                 onClick={() => navigate(-1)}
//                 className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors flex items-center space-x-2"
//               >
//                 <ArrowLeft className="h-4 w-4" />
//                 <span>Back</span>
//               </button>

//               <div>
//                 <h1 className="text-2xl font-bold text-gray-900">Application Details</h1>
//                 <div className="flex items-center space-x-4 text-sm text-gray-600">
//                   <span>ID: {application.applicationId}</span>
//                   <span>•</span>
//                   <span>Patient: {application.patient?.name}</span>
//                   <span>•</span>
//                   <span>Submitted: {formatDate(application.submittedAt)}</span>
//                 </div>
//               </div>
//             </div>

//             <div className="flex items-center space-x-3">
//               <span className={`px-3 py-1 rounded-full text-sm font-medium border ${getStatusColor(application.status)}`}>
//                 {application.status?.replace('_', ' ').charAt(0).toUpperCase() + application.status?.replace('_', ' ').slice(1)}
//               </span>

//               {application.priority && application.priority !== 'normal' && (
//                 <span className={`px-2 py-1 rounded-full text-xs font-medium ${
//                   application.priority === 'urgent' 
//                     ? 'bg-red-100 text-red-800' 
//                     : 'bg-yellow-100 text-yellow-800'
//                 }`}>
//                   {application.priority.charAt(0).toUpperCase() + application.priority.slice(1)}
//                 </span>
//               )}

//               {application.emergency && (
//                 <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs font-medium">
//                   Emergency
//                 </span>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Tab Navigation */}
//       <div className="bg-white border-b border-gray-200">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <nav className="flex space-x-8">
//             {tabs.map((tab) => {
//               const Icon = tab.icon;
//               const isActive = activeTab === tab.id;

//               return (
//                 <button
//                   key={tab.id}
//                   onClick={() => setActiveTab(tab.id)}
//                   className={`flex items-center space-x-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
//                     isActive
//                       ? 'border-teal-500 text-teal-600'
//                       : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
//                   }`}
//                 >
//                   <Icon className="h-4 w-4" />
//                   <span>{tab.label}</span>
//                   {tab.count !== null && tab.count > 0 && (
//                     <span className="bg-teal-100 text-teal-800 text-xs font-medium px-2 py-0.5 rounded-full">
//                       {tab.count}
//                     </span>
//                   )}
//                 </button>
//               );
//             })}
//           </nav>
//         </div>
//       </div>

//       {/* Tab Content */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         {renderTabContent()}
//       </div>

//       {/* Document Viewer Modal */}
//       {showDocumentModal && selectedDocument && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-lg max-w-4xl w-full h-5/6 flex flex-col">
//             <div className="flex items-center justify-between p-4 border-b border-gray-200">
//               <div>
//                 <h3 className="text-lg font-semibold text-gray-900">Document Viewer</h3>
//                 <p className="text-sm text-gray-600">{selectedDocument.fileName}</p>
//               </div>
//               <div className="flex items-center space-x-2">
//                 <button
//                   onClick={() => {
//                     const link = document.createElement('a');
//                     link.href = selectedDocument.url;
//                     link.download = selectedDocument.fileName;
//                     link.click();
//                   }}
//                   className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 flex items-center space-x-2"
//                 >
//                   <Download className="h-4 w-4" />
//                   <span>Download</span>
//                 </button>
//                 <button
//                   onClick={() => setShowDocumentModal(false)}
//                   className="text-gray-400 hover:text-gray-600"
//                 >
//                   <X className="h-6 w-6" />
//                 </button>
//               </div>
//             </div>

//             <div className="flex-1 p-4">
//               {selectedDocument.fileName.toLowerCase().endsWith('.pdf') ? (
//                 <iframe
//                   src={selectedDocument.url}
//                   className="w-full h-full border border-gray-300 rounded"
//                   title="Document Viewer"
//                 />
//               ) : (
//                 <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded">
//                   <img
//                     src={selectedDocument.url}
//                     alt={selectedDocument.fileName}
//                     className="max-w-full max-h-full object-contain"
//                   />
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Letter Viewer Modal */}
//       {showLetterModal && selectedLetter && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-lg max-w-4xl w-full h-5/6 flex flex-col">
//             <div className="flex items-center justify-between p-4 border-b border-gray-200">
//               <div>
//                 <h3 className="text-lg font-semibold text-gray-900">Letter Viewer</h3>
//                 <p className="text-sm text-gray-600">{selectedLetter.title}</p>
//               </div>
//               <div className="flex items-center space-x-2">
//                 <button
//                   onClick={() => {
//                     const link = document.createElement('a');
//                     link.href = selectedLetter.url;
//                     link.download = selectedLetter.fileName;
//                     link.click();
//                   }}
//                   className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 flex items-center space-x-2"
//                 >
//                   <Download className="h-4 w-4" />
//                   <span>Download</span>
//                 </button>
//                 <button
//                   onClick={() => setShowLetterModal(false)}
//                   className="text-gray-400 hover:text-gray-600"
//                 >
//                   <X className="h-6 w-6" />
//                 </button>
//               </div>
//             </div>

//             <div className="flex-1 p-4">
//               <iframe
//                 src={selectedLetter.url}
//                 className="w-full h-full border border-gray-300 rounded"
//                 title="Letter Viewer"
//               />
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ApplicationDetails;

// File Location: src/pages/application/ApplicationDetails.jsx

import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import {
  ArrowLeft,
  User,
  FileText,
  MessageSquare,
  Activity,
  Award,
  Eye,
  Download,
  X,
  Calendar,
  MapPin,
  Phone,
  Mail,
  CreditCard,
  Building,
  Stethoscope,
  Clock,
  CheckCircle,
  XCircle,
  AlertTriangle,
  Star,
  MessageCircle,
  Image,
  FileIcon,
  Info,
  Loader,
  Search,
  Filter,
  MoreVertical,
  Reply,
  Shield,
  History,
  ClipboardList,
  RefreshCw,
  Bell
} from 'lucide-react';
import {
  getPatientApplication,
  getApplicationSanctions,
  uploadDischargeDocument,
  getDocumentDispatches,
  createDocumentDispatch,
  attachDischargeDocToDocuments
} from '../../services/applicationService';
import { initiateDischargeProcess } from '../../services/hospitalService';
import { getApprovedDispatchDocuments, getDischargeItems, subscribeToApplicationUpdates } from '../../services/doctorService';
import { mergeDocumentsToPdf, downloadBlob } from '../../utils/mergePdf';
import { acknowledgeSanctionLetter, acknowledgeKYP } from '../../services/applicationService';
import DiscussionComponent from '../../component/application/DiscussionComponent';
import DisputeManager from '../../components/common/DisputeManager';
import { getHighlightedDisputeId } from '../../utils/disputeNavigation';
import KYPPreviewModal from '../../components/common/KYPPreviewModal';
import FALPreviewModal from '../../components/common/FALPreviewModal';
import { downloadFALPDF } from '../../utils/pdfUtils';
import GlobalSearchBar from '../../components/common/GlobalSearchBar';
import { getDocumentQueries, replyToDocumentQuery, resolveDocumentQuery } from '../../services/documentQueryService';
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../../services/firebaseConfig';

const ApplicationDetails = () => {
  const { applicationId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { userData: user } = useAuth();

  // eNach state (moved top-level for hooks rule compliance)
  const [enachLocal, setEnachLocal] = useState(null);
  const [enachMsg, setEnachMsg] = useState(null);
  const [enachErr, setEnachErr] = useState(null);
  const [enachBusy, setEnachBusy] = useState(false);
  // eNach proof upload state (must be top-level to satisfy hooks rules)
  const [nachProofFile, setNachProofFile] = useState(null);
  const [nachProofErr, setNachProofErr] = useState(null);


  // Get highlighted dispute ID from URL
  const highlightDisputeId = getHighlightedDisputeId(searchParams);

  // State management
  const [activeTab, setActiveTab] = useState('details');
  const [application, setApplication] = useState(null);
  const [sanctions, setSanctions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState({});
  const [unreadCount, setUnreadCount] = useState(0);
  const [disputeCount, setDisputeCount] = useState(0);

  // Modal states
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [showLetterModal, setShowLetterModal] = useState(false);
  const [selectedLetter, setSelectedLetter] = useState(null);

  // KYP preview modal state
  const [showKYPPreview, setShowKYPPreview] = useState(false);
  const [kypPreviewData, setKYPPreviewData] = useState(null);
  // FAL preview modal state
  const [showFALPreview, setShowFALPreview] = useState(false);
  const [showDischargeModal, setShowDischargeModal] = useState(false);
  const [processingDischarge, setProcessingDischarge] = useState(false);
  const [ackActionLoading, setAckActionLoading] = useState({});
  // Dispatch state
  const [dispatching, setDispatching] = useState(false);
  const [dispatchForm, setDispatchForm] = useState({ mode: 'Courier', dispatchedAt: '', trackingId: '', notes: '' });
  // Dispatch will always send the Approved Scrutiny Bundle; no per-item selection
  const [dispatches, setDispatches] = useState([]);
  // Discharge Upload state (batch only)
  const [uploadingDischarge, setUploadingDischarge] = useState(false);
  const [uploadError, setUploadError] = useState('');
  // Bundle download loading
  const [bundleDownloading, setBundleDownloading] = useState(false);
  // Send for review state
  const [reviewRequesting, setReviewRequesting] = useState(false);
  const [reviewNote, setReviewNote] = useState('');
  // Batch selection items [{file, type, description}]
  const [selectedDischargeItems, setSelectedDischargeItems] = useState([]);
  // Dispatch Document single-upload state
  const [dispatchUpload, setDispatchUpload] = useState({ file: null, type: '', title: '', description: '' });
  const [uploadingDispatchDocs, setUploadingDispatchDocs] = useState(false);
  const [dispatchUploadError, setDispatchUploadError] = useState('');
  // Review confirmation modal (before sending to doctor)
  const [showReviewConfirm, setShowReviewConfirm] = useState(false);
  // Doctor-entered discharge items summary (read-only for hospital)
  const [dischargeItems, setDischargeItems] = useState([]);
  // Refresh loading state for discharge data
  const [refreshingDischargeData, setRefreshingDischargeData] = useState(false);

  // Live updates so doctor approvals reflect without refresh
  useEffect(() => {
    if (!applicationId) return;
    const unsub = subscribeToApplicationUpdates(applicationId, (updated) => {
      setApplication((prev) => ({ ...(prev || {}), ...(updated || {}) }));
    });
    return () => {
      try { if (typeof unsub === 'function') unsub(); } catch (_) { }
    };
  }, [applicationId]);
  const [loadingDischargeItems, setLoadingDischargeItems] = useState(false);
  // Discharge dates state
  const [dischargeDates, setDischargeDates] = useState({
    admissionDate: '',
    dischargeDate: ''
  });
  // Stay dates confirmation + gating for uploads
  const [stayDatesConfirming, setStayDatesConfirming] = useState(false);
  const [stayDatesConfirmed, setStayDatesConfirmed] = useState(false);
  // Scrutiny simplified: per-item upload states
  const [scrutinyUploading, setScrutinyUploading] = useState({});
  // Scrutiny per-item decision: { [key]: 'accepted'|'decline'|undefined }
  const [scrutinyDecision, setScrutinyDecision] = useState({});
  // Scrutiny per-item action loading for accept/decline actions
  const [scrutinyActionLoading, setScrutinyActionLoading] = useState({});

  // Document query state
  const [documentQueries, setDocumentQueries] = useState({});
  const [queryDetailsModal, setQueryDetailsModal] = useState(null); // { docKey, queries }
  const [replyText, setReplyText] = useState('');
  const [replyingToQuery, setReplyingToQuery] = useState(null);
  const [uploadingQueryDoc, setUploadingQueryDoc] = useState(false);
  const [queryDocFile, setQueryDocFile] = useState(null);

  // Sync local eNach snapshot when application workflow updates (must come AFTER application state declaration)
  useEffect(() => {
    const enach = application?.workflow?.enach || null;
    setEnachLocal(enach);
  }, [application?.workflow?.enach]);

  // Forced download helper: fetches the file as a Blob and triggers a save
  const inferExtFromType = (type = '') => {
    const t = type.toLowerCase();
    if (t.includes('pdf')) return 'pdf';
    if (t.includes('jpeg')) return 'jpg';
    if (t.includes('jpg')) return 'jpg';
    if (t.includes('png')) return 'png';
    if (t.includes('webp')) return 'webp';
    if (t.includes('csv')) return 'csv';
    if (t.includes('excel') || t.includes('spreadsheet') || t.includes('ms-excel')) return 'xls';
    if (t.includes('sheet') || t.includes('openxmlformats-officedocument.spreadsheetml')) return 'xlsx';
    return '';
  };
  const getNameFromUrl = (url = '') => {
    try {
      const u = new URL(url);
      const p = u.pathname.split('/').pop() || 'file';
      // Try to preserve original filename if present in query (common with Firebase URLs)
      const alt = u.searchParams.get('alt') || '';
      return decodeURIComponent(p || alt || 'file');
    } catch {
      try { return decodeURIComponent(url.split('?')[0].split('/').pop() || 'file'); } catch { return 'file'; }
    }
  };
  const ensureExtension = (base, ext) => {
    if (!ext) return base;
    const lower = (base || '').toLowerCase();
    return (lower.endsWith('.' + ext) || lower.match(/\.[a-z0-9]{2,5}$/)) ? base : `${base}.${ext}`;
  };
  const downloadFile = async (url, filename) => {
    if (!url) return;
    try {
      const res = await fetch(url, { mode: 'cors' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const ct = res.headers.get('content-type') || '';
      const blob = await res.blob();
      const ext = inferExtFromType(ct) || (filename && filename.split('.').pop());
      const safeName = ensureExtension(filename || getNameFromUrl(url), ext || '');
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = safeName || 'download';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(objectUrl);
    } catch (e) {
      // Last resort: open in new tab
      window.open(url, '_blank', 'noopener');
    }
  };
  // Tabs: show Discharge only after hospital has accepted Final Approval Letter (FAL)
  const falId = application?.workflow?.dischargeSettlement?.finalApprovalLetterId;
  const falUrl = application?.workflow?.dischargeSettlement?.finalApprovalLetterUrl;
  const falAck = falId ? application?.workflow?.acknowledgements?.[falId] : null;
  // Consider legacy acknowledgement location as well if present
  const falAckLegacyAccepted = application?.workflow?.dischargeSettlement?.hospitalAcknowledgement?.status === 'accepted';
  const isFALAcceptedByHospital = Boolean(
    falUrl && ((falAck?.status === 'accepted') || falAckLegacyAccepted)
  );
  // Also allow Discharge tab when KYP is accepted and hospital initiated discharge
  const mv = application?.workflow?.medicalVerification || {};
  const kypAckAccepted = (
    mv?.kypHospitalAcknowledgement?.status === 'accepted' ||
    mv?.kypAck === 'accepted' ||
    mv?.kypStatus === 'accepted'
  );
  const dischargeInitiatedFlag = Boolean(
    application?.dischargeInitiated ||
    application?.dischargeStatus === 'initiated' ||
    application?.workflow?.dischargeSettlement?.dischargeInitiated
  );
  const showDischargeTab = Boolean(isFALAcceptedByHospital || (kypAckAccepted && dischargeInitiatedFlag));

  const tabs = [
    { id: 'details', label: 'Application Details', icon: User, count: null },
    { id: 'documents', label: 'Documents', icon: FileText, count: null },
    // { id: 'discussions', label: 'Discussions', icon: MessageSquare, count: unreadCount },
    { id: 'disputes', label: 'Queries & Query', icon: Shield, count: disputeCount },
    { id: 'status', label: 'Status Timeline', icon: Activity, count: null },
    { id: 'sanctions', label: 'Sanctions & Letters', icon: Award, count: null },
    // Enable Discharge/Dispatch phase after Final Approval Letter is accepted by hospital
    ...(showDischargeTab ? [{ id: 'discharge', label: 'Discharge Process', icon: ClipboardList, count: null }] : [])
  ];

  const loadApplicationData = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getPatientApplication(applicationId);
      if (result.success) {
        setApplication(result.application);
        // Initialize discharge dates from application data
        setDischargeDates({
          admissionDate: result.application.medical?.admissionDate || '',
          dischargeDate: result.application.medical?.dischargeDate || ''
        });
      } else {
        console.error('Error loading application:', result.error);
      }
    } catch (error) {
      console.error('Error loading application:', error);
    } finally {
      setLoading(false);
    }
  }, [applicationId]);

  const loadSanctions = useCallback(async () => {
    try {
      const result = await getApplicationSanctions(applicationId);
      if (result.success) {
        setSanctions(result.sanctions);
      }
    } catch (error) {
      console.error('Error loading sanctions:', error);
    }
  }, [applicationId]);

  useEffect(() => {
    loadApplicationData();
  }, [loadApplicationData]);

  // Load document queries
  useEffect(() => {
    if (!application?.applicationId) return;
    const loadQueries = async () => {
      try {
        const result = await getDocumentQueries(application.applicationId);
        if (result.success) {
          const byKey = {};
          result.queries.forEach(q => {
            if (!byKey[q.documentKey]) byKey[q.documentKey] = [];
            byKey[q.documentKey].push(q);
          });
          setDocumentQueries(byKey);
        }
      } catch (err) {
        console.error('Failed to load document queries:', err);
      }
    };
    loadQueries();
  }, [application?.applicationId]);

  // Reflect persisted confirmation in local state when application updates
  useEffect(() => {
    const confirmed = application?.workflow?.dischargeSettlement?.stayDatesConfirmation?.status === 'confirmed';
    setStayDatesConfirmed(!!confirmed);
  }, [application?.workflow?.dischargeSettlement?.stayDatesConfirmation?.status]);

  useEffect(() => {
    if (activeTab === 'sanctions') {
      loadSanctions();
    }
  }, [activeTab, loadSanctions]);

  // Load dispatches when Discharge tab is active
  const loadDispatches = useCallback(async () => {
    try {
      if (!application?.applicationId) return;
      const res = await getDocumentDispatches(application.applicationId);
      if (res.success) setDispatches(res.dispatches);
    } catch (e) {
      console.error('Error loading dispatches', e);
    }
  }, [application?.applicationId]);
  // Load scrutiny checklist

  // Load discharge items that doctor added/reviewed
  const loadDischargeItems = useCallback(async () => {
    try {
      if (!application?.applicationId) return;
      setLoadingDischargeItems(true);
      const res = await getDischargeItems(application.applicationId);
      if (res.success) {
        const items = (res.items || []).map((it) => ({
          ...it,
          quantity: Number(it.quantity ?? 0),
          unitRate: Number(it.unitRate ?? 0),
          eligibleUnitRate: Number(it.eligibleUnitRate ?? 0),
          billedAmount: Number(it.billedAmount ?? 0),
          eligibleAmount: Number(it.eligibleAmount ?? 0),
          payableType: it.payableType || 'payable',
          remarks: it.remarks || '',
        }));
        setDischargeItems(items);
      }
    } catch (e) {
      console.error('Error loading discharge items', e);
    } finally {
      setLoadingDischargeItems(false);
    }
  }, [application?.applicationId]);

  useEffect(() => {
    if (activeTab === 'discharge') {
      // Refresh application data to ensure discharge documents are up-to-date
      loadApplicationData();
      loadDispatches();
      loadDischargeItems();
    }
  }, [activeTab, loadApplicationData, loadDispatches, loadDischargeItems]);

  // Auto-switch to disputes tab when dispute is highlighted from notification
  useEffect(() => {
    if (highlightDisputeId) {
      setActiveTab('disputes');
    }
  }, [highlightDisputeId]);

  // Confirm on refresh/close and once on back navigation
  useEffect(() => {
    let isNavigatingBack = false;
    
    const handleBeforeUnload = (e) => {
      // Only prevent unload if NOT navigating back (i.e., only for refresh/close tab)
      if (isNavigatingBack) {
        return; // Allow navigation to proceed without prompt
      }
      e.preventDefault();
      e.returnValue = ""; // triggers native confirm for refresh/close only
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    // Push a dummy state so the first back triggers our handler
    try { window.history.pushState(null, '', window.location.href); } catch (_) { }

    const handlePopState = () => {
      if (isNavigatingBack) return;
      const confirmed = window.confirm('Are you sure you want to leave this page? Unsaved changes may be lost.');
      if (confirmed) {
        isNavigatingBack = true; // Set flag BEFORE removing listeners
        window.removeEventListener('popstate', handlePopState);
        window.removeEventListener('beforeunload', handleBeforeUnload);
        // Skip the injected dummy state and leave immediately
        navigate(-2);
      } else {
        // Stay on the page by restoring the current state
        try { window.history.pushState(null, '', window.location.href); } catch (_) { }
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);

  const handleUnreadCountChange = (count) => {
    setUnreadCount(count);
  };

  const handleDisputeCountChange = (count) => {
    setDisputeCount(count);
  };

  const openDocument = (document) => {
    setSelectedDocument(document);
    setShowDocumentModal(true);
  };

  const openLetter = (letter) => {
    // Handle KYP letters specially - generate PDF dynamically (support both flags and legacy type)
    if (letter?.isKYPLetter || letter?.type === 'kyp') {
      handleKYPPreview(letter);
      return;
    }
    // Handle FAL (Final Approval Letter) with live modal preview
    const isFAL = letter?.type === 'approval' || letter?.id === 'approval' || (letter?.title || '').toLowerCase().includes('final approval');
    if (isFAL) {
      setShowFALPreview(true);
      return;
    }
    setSelectedLetter(letter);
    setShowLetterModal(true);
  };

  // Helpers: Determine acknowledgement status for KYP and sanctions
  const getKYPAck = () => application?.workflow?.medicalVerification?.kypHospitalAcknowledgement || { status: 'pending' };
  const getKYPDoctorApproval = () => application?.workflow?.medicalVerification?.kypApproval || null;
  const getSanctionAck = (sanction) => sanction?.hospitalAcknowledgement || { status: 'pending' };

  // Actions: accept/challenge KYP
  // Modal state for challenge comments
  const [showChallengeModal, setShowChallengeModal] = useState(false);
  const [challengeContext, setChallengeContext] = useState({ type: null, sanction: null });
  const [challengeComment, setChallengeComment] = useState('');

  const openChallengeModal = (type, sanction = null) => {
    setChallengeContext({ type, sanction });
    setChallengeComment('');
    setShowChallengeModal(true);
  };

  const submitChallenge = async () => {
    if (challengeContext.type === 'kyp') {
      await handleKYPAcknowledgement('challenged', challengeComment);
    } else if (challengeContext.type === 'sanction' && challengeContext.sanction) {
      await handleSanctionAcknowledgement(challengeContext.sanction, 'challenged', challengeComment);
    }
    setShowChallengeModal(false);
  };

  const handleKYPAcknowledgement = async (status, overrideComment = '') => {
    const comment = status === 'challenged' ? (overrideComment || '') : '';
    setAckActionLoading((p) => ({ ...p, kyp: true }));
    try {
      const res = await acknowledgeKYP(applicationId, { status, comment, hospitalUserId: 'hospital', hospitalUserName: application.hospitalName });
      if (!res.success) throw new Error(res.error || 'Failed');
      await loadApplicationData();
    } catch (e) {
      alert(e.message || 'Failed to update KYP acknowledgement');
    } finally {
      setAckActionLoading((p) => ({ ...p, kyp: false }));
    }
  };

  // Actions: accept/challenge a sanction letter
  const handleSanctionAcknowledgement = async (sanction, status, overrideComment = '') => {
    const comment = status === 'challenged' ? (overrideComment || '') : '';
    setAckActionLoading((p) => ({ ...p, [sanction.id]: true }));
    try {
      const res = await acknowledgeSanctionLetter(applicationId, sanction.id, { status, comment, hospitalUserId: 'hospital', hospitalUserName: application.hospitalName });
      if (!res.success) throw new Error(res.error || 'Failed');
      await loadSanctions();
    } catch (e) {
      alert(e.message || 'Failed to update acknowledgement');
    } finally {
      setAckActionLoading((p) => ({ ...p, [sanction.id]: false }));
    }
  };

  const handleKYPPreview = (letter) => {
    // Open unified KYP preview modal used across the app
    setKYPPreviewData({ kypData: letter?.kypData || null });
    setShowKYPPreview(true);
  };

  const handleLetterDownload = async (letter) => {
    try {
      if (letter?.isKYPLetter || letter?.type === 'kyp') {
        // Prefer server-stored comprehensive PDF if available, else fallback to live generation matching the preview
        const { downloadKYPPDFFromFirestore, downloadKYPPDF } = await import('../../utils/pdfUtils');
        // Force use of comprehensive generator which now embeds leadGenerator logo via utils
        const byId = await downloadKYPPDFFromFirestore(application?.applicationId, { template: 'comprehensive' });
        if (!byId?.success) {
          const fileName = `KYP_Comprehensive_${application?.applicationId || Date.now()}_${Date.now()}.pdf`;
          const res = await downloadKYPPDF(application, letter.kypData, fileName, { template: 'comprehensive' });
          if (!res?.success) throw new Error(res?.error || 'Failed to generate KYP letter');
        }
      } else if (letter?.type === 'approval' || letter?.id === 'approval' || (letter?.title || '').toLowerCase().includes('final approval')) {
        // Generate FAL on the fly with comprehensive template for consistency
        const remarks = application?.workflow?.dischargeSettlement?.comments || '';
        const res = await downloadFALPDF(application, { remarks, template: 'comprehensive' });
        if (!res?.success) throw new Error(res?.error || 'Failed to generate FAL');
      } else {
        // Regular letter download via forced download
        await downloadFile(letter.url, letter.fileName || `${letter.title || 'letter'}`);
      }
    } catch (error) {
      console.error('Error downloading letter:', error);
      alert('Failed to download letter. Please try again.');
    }
  };

  const handleInitiateDischargeProcess = async () => {
    setProcessingDischarge(true);
    try {
      const result = await initiateDischargeProcess(applicationId, application.hospitalId, {
        kypCompleted: true,
        initiatedBy: 'hospital',
        initiatedAt: new Date()
      });

      if (result.success) {
        // Refresh application data to show updated status
        await loadApplicationData();
        setShowDischargeModal(false);
        alert('Discharge process initiated successfully!');
      } else {
        alert('Failed to initiate discharge process: ' + result.error);
      }
    } catch (error) {
      console.error('Error initiating discharge process:', error);
      alert('Error initiating discharge process. Please try again.');
    } finally {
      setProcessingDischarge(false);
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'submitted':
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'under_review':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'approved':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'rejected':
        return 'bg-red-100 text-red-800 border-red-200';
      case 'pending_documents':
        return 'bg-orange-100 text-orange-800 border-orange-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  // Document query handlers
  const handleReplyToQuery = async (queryId) => {
    if (!replyText.trim()) {
      alert('Please enter a reply');
      return;
    }
    try {
      setActionLoading(prev => ({ ...prev, [`reply_${queryId}`]: true }));
      const result = await replyToDocumentQuery(
        application.applicationId,
        queryId,
        replyText.trim(),
        {
          uid: user.uid || 'hospital',
          name: user.profile?.hospitalName || application.hospitalName || 'Hospital',
          email: user.email || '',
          team: 'hospital',
        }
      );
      if (result.success) {
        alert('Reply sent successfully');
        setReplyText('');
        setReplyingToQuery(null);
        // Reload queries
        const updatedQueries = await getDocumentQueries(application.applicationId);
        if (updatedQueries.success) {
          const byKey = {};
          updatedQueries.queries.forEach(q => {
            if (!byKey[q.documentKey]) byKey[q.documentKey] = [];
            byKey[q.documentKey].push(q);
          });
          setDocumentQueries(byKey);
        }
      } else {
        alert('Failed to send reply: ' + result.error);
      }
    } catch (err) {
      console.error('Error replying to query:', err);
      alert('Failed to send reply');
    } finally {
      setActionLoading(prev => ({ ...prev, [`reply_${queryId}`]: false }));
    }
  };

  const handleResolveQuery = async (queryId) => {
    if (!queryDocFile) {
      alert('Please upload the updated document');
      return;
    }
    try {
      setUploadingQueryDoc(true);
      // Upload document to Firebase Storage
      const fileName = queryDocFile.name;
      const timestamp = Date.now();
      const storagePath = `applications/${application.hospitalId}/query_docs/${timestamp}_${fileName}`;
      const fileRef = storageRef(storage, storagePath);
      await uploadBytes(fileRef, queryDocFile);
      const downloadURL = await getDownloadURL(fileRef);

      // Resolve query with new document URL
      const result = await resolveDocumentQuery(
        application.applicationId,
        queryId,
        downloadURL,
        fileName,
        {
          uid: user.uid || 'hospital',
          name: user.profile?.hospitalName || application.hospitalName || 'Hospital',
        }
      );

      if (result.success) {
        alert('Query resolved and document updated successfully');
        setQueryDocFile(null);
        setQueryDetailsModal(null);
        // Reload application and queries
        await loadApplicationData();
        const updatedQueries = await getDocumentQueries(application.applicationId);
        if (updatedQueries.success) {
          const byKey = {};
          updatedQueries.queries.forEach(q => {
            if (!byKey[q.documentKey]) byKey[q.documentKey] = [];
            byKey[q.documentKey].push(q);
          });
          setDocumentQueries(byKey);
        }
      } else {
        alert('Failed to resolve query: ' + result.error);
      }
    } catch (err) {
      console.error('Error resolving query:', err);
      alert('Failed to resolve query');
    } finally {
      setUploadingQueryDoc(false);
    }
  };

  // Normalize Firestore Timestamp/Date/string into JS Date
  const toJsDate = (ts) => {
    if (!ts) return null;
    try {
      return ts.toDate ? ts.toDate() : new Date(ts);
    } catch (e) {
      return null;
    }
  };

  // Discharge document type suggestions (single source of truth)
  const DISCHARGE_TYPE_SUGGESTIONS = [
    'Discharge Summary',
    'Final Medical Bill',
   
    'ICP Papers',
    'Bill Breakup',
    'OT Notes',
    'Anaesthesia Notes',
    'Nursing Notes',

    'Pharmacy Bills',
    'Investigation/Diagnostics',
    'Implant Bill',
    

 
   
  ];
 
  // Submitted vs Missing types for review confirmation modal
  const dischargeDocsForConfirm = Array.isArray(application?.dischargeDocuments) ? application.dischargeDocuments : [];
  const submittedTypes = Array.from(new Set(dischargeDocsForConfirm.map((d) => (d.type || d.title || '').trim()).filter(Boolean)));
  const missingTypes = DISCHARGE_TYPE_SUGGESTIONS.filter((s) => !submittedTypes.some((t) => t.toLowerCase() === s.toLowerCase()));

  // Hoisted function to send discharge documents for doctor review
  const sendDispatchForReview = async () => {
    try {
      setReviewRequesting(true);
      const { requestDispatchReview } = await import('../../services/applicationService');
      const res = await requestDispatchReview(application.applicationId, {
        note: reviewNote,
        requestedBy: 'hospital',
        requestedByName: application.hospitalName || 'Hospital'
      });
      if (!res.success) throw new Error(res.error || 'Failed');
      await loadApplicationData();
      alert('Sent to doctor for review');
    } catch (e) {
      console.error('sendForReview error', e);
      alert(e.message || 'Failed to send for review');
    } finally {
      setReviewRequesting(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50 flex items-center justify-center">
        <div className="text-center">
          <Loader className="h-8 w-8 animate-spin text-teal-500 mx-auto mb-4" />
          <p className="text-gray-600">Loading application details...</p>
        </div>
      </div>
    );
  }

  if (!application) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50 flex items-center justify-center">
        <div className="text-center">
          <FileText className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Application Not Found</h3>
          <p className="text-gray-600 mb-4">The requested application could not be found.</p>
          <button
            onClick={() => navigate(-1)}
            className="bg-teal-600 text-white px-4 py-2 rounded-lg hover:bg-teal-700 transition-colors flex items-center space-x-2"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>Go Back</span>
          </button>
        </div>
      </div>
    );
  }

  const renderApplicationDetails = () => (
    <div className="space-y-6">
      {/* Patient Information */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center space-x-3 mb-6">
          <div className="bg-teal-100 p-2 rounded-lg">
            <User className="h-5 w-5 text-teal-600" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900">Patient Information</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div>
            <label className="text-sm font-medium text-gray-500">Patient Name</label>
            <p className="text-lg font-semibold text-gray-900">{application.patient?.name}</p>
          </div>

          <div>
            <label className="text-sm font-medium text-gray-500">Age & Gender</label>
            <p className="text-gray-900">{application.patient?.age} years, {application.patient?.gender}</p>
          </div>

          <div>
            <label className="text-sm font-medium text-gray-500">Contact</label>
            <div className="space-y-1">
              <div className="flex items-center space-x-2">
                <Phone className="h-3 w-3 text-gray-400" />
                <p className="text-sm text-gray-900">{application.patient?.phone}</p>
              </div>
              {application.patient?.email && (
                <div className="flex items-center space-x-2">
                  <Mail className="h-3 w-3 text-gray-400" />
                  <p className="text-sm text-gray-900">{application.patient?.email}</p>
                </div>
              )}
            </div>
          </div>

          <div>
            <label className="text-sm font-medium text-gray-500">Aadhar Number</label>
            <p className="text-gray-900 font-mono">****-****-{application.patient?.kyc?.aadharNumber?.slice(-4)}</p>
          </div>

          <div>
            <label className="text-sm font-medium text-gray-500">Address</label>
            <div className="flex items-start space-x-2">
              <MapPin className="h-3 w-3 text-gray-400 mt-1" />
              <p className="text-sm text-gray-900">{application.patient?.address}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Medical History - NEW SECTION */}
      {(application.medicalHistory || application.surgicalHistory || application.medicalHistoryDocsCount > 0) && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="flex items-center space-x-3 mb-6">
            <div className="bg-orange-100 p-2 rounded-lg">
              <History className="h-5 w-5 text-orange-600" />
            </div>
            <h2 className="text-xl font-semibold text-gray-900">Medical History</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {application.medicalHistory && (
              <div>
                <label className="text-sm font-medium text-gray-500">Medical History</label>
                <p className="text-gray-900 mt-1">{application.medicalHistory}</p>
              </div>
            )}

            {application.surgicalHistory && (
              <div>
                <label className="text-sm font-medium text-gray-500">Surgical History</label>
                <p className="text-gray-900 mt-1">{application.surgicalHistory}</p>
              </div>
            )}
          </div>

          {/* Medical History Documents */}
          {application.medicalHistoryDocsCount > 0 && (
            <div className="mt-4">
              <label className="text-sm font-medium text-gray-500">Medical History Documents</label>
              <p className="text-sm text-gray-600 mt-1">
                {application.medicalHistoryDocsCount} document(s) uploaded
              </p>
            </div>
          )}
        </div>
      )}

      {/* Medical Information */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center space-x-3 mb-6">
          <div className="bg-blue-100 p-2 rounded-lg">
            <Stethoscope className="h-5 w-5 text-blue-600" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900">Medical Information</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-4">
            <div>
              <label className="text-sm font-medium text-gray-500">Diagnosis</label>
              <p className="text-gray-900 font-medium">{application.medical?.diagnosis}</p>
            </div>

            <div>
              <label className="text-sm font-medium text-gray-500">Treatment Type</label>
              <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${application.medical?.treatmentType === 'surgical'
                  ? 'bg-red-100 text-red-800'
                  : 'bg-blue-100 text-blue-800'
                }`}>
                {application.medical?.treatmentType?.charAt(0).toUpperCase() + application.medical?.treatmentType?.slice(1)}
              </span>
            </div>

            <div>
              <label className="text-sm font-medium text-gray-500">Procedure Details</label>
              <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${application.medical?.treatmentType === 'surgical'
                  ? 'bg-red-100 text-red-800'
                  : 'bg-blue-100 text-blue-800'
                }`}>
                {application.medical?.procedureDetails}
              </span>
            </div>

            {/* NEW: Treatment Plan */}
            {application.treatmentPlanned && (
              <div>
                <label className="text-sm font-medium text-gray-500">Treatment Plan</label>
                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${application.treatmentPlanned === 'emergency'
                    ? 'bg-red-100 text-red-800'
                    : 'bg-green-100 text-green-800'
                  }`}>
                  {application.treatmentPlanned?.charAt(0).toUpperCase() + application.treatmentPlanned?.slice(1)}
                </span>
              </div>
            )}

            <div>
              <label className="text-sm font-medium text-gray-500">Consulting Doctor</label>
              <p className="text-gray-900">{application.medical?.doctor?.name}</p>
              <p className="text-sm text-gray-600">{application.medical?.doctor?.designation}</p>
            </div>

            <div>
              <label className="text-sm font-medium text-gray-500">Procedure Details</label>
              <p className="text-gray-900">{application.medical?.procedureDetails}</p>
            </div>
          </div>

          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium text-gray-500">Admission Date</label>
                <div className="flex items-center space-x-2">
                  <Calendar className="h-3 w-3 text-gray-400" />
                  <p className="text-sm text-gray-900">{application.medical?.admissionDate}</p>
                </div>
              </div>

              <div>
                <label className="text-sm font-medium text-gray-500">Discharge Date</label>
                <div className="flex items-center space-x-2">
                  <Calendar className="h-3 w-3 text-gray-400" />
                  <p className="text-sm text-gray-900">{application.medical?.dischargeDate || 'TBD'}</p>
                </div>
              </div>
            </div>

            <div>
              <label className="text-sm font-medium text-gray-500">Estimated Cost</label>
              <p className="text-lg font-semibold text-gray-900">₹{application.medical?.estimatedCost?.toLocaleString('en-IN')}</p>
            </div>

            {/* UPDATED: Treatment History - now shows new structure */}
            {application.medical?.treatments && application.medical.treatments.length > 0 && (
              <div>
                <label className="text-sm font-medium text-gray-500 mb-2 block">Additional Diagnoses</label>
                <div className="space-y-2">
                  {application.medical.treatments.map((treatment, index) => (
                    <div key={index} className="bg-gray-50 rounded-lg p-3">
                      <div className="flex justify-between items-start">
                        <div>
                          <p className="font-medium text-gray-900">{treatment.diagnosisName || treatment.treatmentName}</p>
                          {treatment.treatmentType && (
                            <p className="text-sm text-gray-600">Type: {treatment.treatmentType}</p>
                          )}
                          {treatment.procedureName && (
                            <p className="text-sm text-gray-600">Procedure: {treatment.procedureName}</p>
                          )}
                          <p className="text-sm text-gray-600">{treatment.description}</p>
                        </div>
                        {/* Show cost and date only if they exist (backward compatibility) */}
                        {(treatment.cost || treatment.date) && (
                          <div className="text-right">
                            {treatment.cost && <p className="text-sm font-medium text-gray-900">₹{treatment.cost?.toLocaleString('en-IN')}</p>}
                            {treatment.date && <p className="text-xs text-gray-500">{treatment.date}</p>}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* NEW: Additional Remarks */}
            {application.remarks && (
              <div>
                <label className="text-sm font-medium text-gray-500">Additional Remarks</label>
                <p className="text-gray-900">{application.remarks}</p>
              </div>
            )}

            {/* NEW: Payment Preference from Finance */}
            {(() => {
              const paymentOption = application?.workflow?.financialVerification?.assessment?.paymentOption;
              if (!paymentOption) return null;
              const label = paymentOption === 'hospital_pdc' ? 'Hospital PDC' : 'Loan';
              const badgeCls = paymentOption === 'hospital_pdc'
                ? 'bg-emerald-100 text-emerald-800 border border-emerald-200'
                : 'bg-indigo-100 text-indigo-800 border border-indigo-200';
              return (
                <div>
                  <label className="text-sm font-medium text-gray-500">Payment Preference</label>
                  <div className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold mt-1 ${badgeCls}`}>
                    {label}
                  </div>
                </div>
              );
            })()}
          </div>
        </div>
      </div>

      {/* eNach Section (visible after FAL accepted). Use unified acceptance check (legacy or new acknowledgements map). */}
      {isFALAcceptedByHospital && renderENachSection()}

      {/* Policy Information */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center space-x-3 mb-6">
          <div className="bg-green-100 p-2 rounded-lg">
            <Shield className="h-5 w-5 text-green-600" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900">Insurance Policy</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div>
            <label className="text-sm font-medium text-gray-500">Policy Number</label>
            <p className="text-gray-900 font-mono">{application.policy?.number}</p>
          </div>

          <div>
            <label className="text-sm font-medium text-gray-500">Insurance Company</label>
            <p className="text-gray-900">{application.policy?.insuranceCompany}</p>
          </div>

          <div>
            <label className="text-sm font-medium text-gray-500">Policy Type</label>
            <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${application.policy?.type === 'corporate'
                ? 'bg-purple-100 text-purple-800'
                : 'bg-blue-100 text-blue-800'
              }`}>
              {application.policy?.type?.charAt(0).toUpperCase() + application.policy?.type?.slice(1)}
            </span>
          </div>

          {/* REMOVED: Coverage Amount as requested */}

          <div>
            <label className="text-sm font-medium text-gray-500">Policy Period</label>
            <p className="text-gray-900">{application.policy?.startDate} to {application.policy?.endDate}</p>
          </div>

          {application.policy?.tpaName && (
            <div>
              <label className="text-sm font-medium text-gray-500">TPA</label>
              <p className="text-gray-900">{application.policy.tpaName}</p>
            </div>
          )}
        </div>
      </div>

      {/* Policy Holder Information */}
      {application.policyHolder && !application.policyHolder.isSelf && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="flex items-center space-x-3 mb-6">
            <div className="bg-purple-100 p-2 rounded-lg">
              <User className="h-5 w-5 text-purple-600" />
            </div>
            <h2 className="text-xl font-semibold text-gray-900">Policy Holder Information</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div>
              <label className="text-sm font-medium text-gray-500">Policy Holder Name</label>
              <p className="text-gray-900">{application.policyHolder.name}</p>
            </div>

            <div>
              <label className="text-sm font-medium text-gray-500">Age & Gender</label>
              <p className="text-gray-900">{application.policyHolder.age} years, {application.policyHolder.gender}</p>
            </div>

            <div>
              <label className="text-sm font-medium text-gray-500">Relationship</label>
              <p className="text-gray-900">{application.policyHolder.relationshipWithPatient}</p>
            </div>

            <div>
              <label className="text-sm font-medium text-gray-500">Contact</label>
              <p className="text-gray-900">{application.policyHolder.phone}</p>
            </div>

            <div>
              <label className="text-sm font-medium text-gray-500">Nominee</label>
              <p className="text-gray-900">{application.policyHolder.nominee?.name}</p>
              <p className="text-sm text-gray-600">{application.policyHolder.nominee?.relationshipWithNominee}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  const renderENachSection = () => {
    const enach = application?.workflow?.enach || {};
    const canMarkDone = enachLocal?.status === 'initiated' && enachLocal?.status !== 'completed';
    const handleMarkENachDone = async () => {
      setNachProofErr(null);
      if (!nachProofFile) {
        setNachProofErr('Please upload an eNach done screenshot (PNG/JPG/PDF)');
        return;
      }
      setEnachBusy(true);
      setEnachErr(null); setEnachMsg(null);
      setEnachLocal(prev => ({ ...prev, status: 'completed', hospitalCompletedAt: new Date(), hospitalCompletedBy: user?.uid || 'hospital' }));
      try {
        // Upload proof to storage
        const { uploadFile } = await import('../../services/fileUploadService');
        const time = Date.now();
        const safeName = (nachProofFile.name || 'enach_proof').replace(/[^a-zA-Z0-9._-]/g, '_');
        const storagePath = `applications/${application.hospitalId}/${application.applicationId}/enach/${time}_${Math.random().toString(36).slice(2, 8)}_${safeName}`;
        const uploaded = await uploadFile(nachProofFile, storagePath);
        const proofMeta = {
          url: uploaded.downloadURL,
          name: uploaded.metadata?.name || nachProofFile.name,
          size: uploaded.metadata?.size || nachProofFile.size,
          type: uploaded.metadata?.type || nachProofFile.type,
          uploadedAt: uploaded.metadata?.uploadedAt || new Date().toISOString(),
          uploadedBy: user?.uid || 'hospital',
          uploaderName: application.hospitalName || 'Hospital',
          storagePath: uploaded.metadata?.fullPath
        };

        const { markENachCompleted } = await import('../../services/financialservice');
        const res = await markENachCompleted(application.applicationId, user?.uid || 'hospital', proofMeta);
        if (!res.success) throw new Error(res.error || 'Failed');
        setEnachMsg('eNach marked completed');
        loadApplicationData();
      } catch (e) {
        console.error('markENachCompleted error', e);
        setEnachErr(e.message || 'Failed to mark eNach done');
        setEnachLocal(enach); // revert
      } finally {
        setEnachBusy(false);
      }
    };
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-3">
            <div className="bg-indigo-100 p-2 rounded-lg">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l2 2m6-2a8 8 0 11-16 0 8 8 0 0116 0z" /></svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-900">eNach Process</h2>
          </div>
          {(enachLocal?.status === 'completed') && (
            <span className="px-3 py-1 text-xs font-medium bg-green-50 text-green-700 rounded-full border border-green-200">Completed</span>
          )}
          {(enachLocal?.status === 'initiated') && enachLocal?.status !== 'completed' && (
            <span className="px-3 py-1 text-xs font-medium bg-indigo-50 text-indigo-700 rounded-full border border-indigo-200">Initiated</span>
          )}
        </div>
        {(!enachLocal?.status) && (
          <p className="text-sm text-gray-600">Finance team will initiate eNach shortly after FAL acceptance.</p>
        )}
        {enachLocal?.status && (
          <div className="space-y-4">
            {enachLocal?.link && (
              <div>
                <label className="text-xs font-medium text-gray-500">eNach Link</label>
                <p className="text-sm">
                  <a className="text-indigo-600 hover:underline break-all" href={enachLocal.link} target="_blank" rel="noreferrer">{enachLocal.link}</a>
                </p>
              </div>
            )}
            {enachLocal?.comments && (
              <div>
                <label className="text-xs font-medium text-gray-500">Finance Comments</label>
                <p className="text-sm text-gray-800">{enachLocal.comments}</p>
              </div>
            )}
            {canMarkDone && enachLocal?.status === 'initiated' && (
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Upload eNach Done Screenshot (required)</label>
                <input type="file" accept="image/png,image/jpeg,application/pdf" onChange={(e) => setNachProofFile(e.target.files && e.target.files[0])} className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm bg-white" />
                {nachProofFile && (
                  <p className="text-xs text-gray-600 mt-1">{nachProofFile.name} • {(nachProofFile.size / 1024).toFixed(1)} KB</p>
                )}
                {nachProofErr && <p className="text-xs text-red-600 mt-1">{nachProofErr}</p>}
                <button disabled={enachBusy} onClick={handleMarkENachDone} className="mt-2 bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 disabled:opacity-60 text-sm font-medium">{enachBusy ? 'Saving…' : 'Mark eNach Done'}</button>
                <p className="text-xs text-gray-500 mt-2">Attach the confirmation screenshot before marking completed.</p>
              </div>
            )}
            {enachMsg && <div className="text-xs text-green-700 bg-green-50 border border-green-200 rounded p-2">{enachMsg}</div>}
            {enachErr && <div className="text-xs text-red-700 bg-red-50 border border-red-200 rounded p-2">{enachErr}</div>}
          </div>
        )}
      </div>
    );
  };

  const renderDocuments = () => {
    // Organize documents by category
    const documentCategories = {
      'Patient KYC': [],
      'Policy Holder KYC': [],
      'Policy Documents': [],
      'Medical History': [],
      'Treatment Documents': []
    };

    // Process documents and categorize them
    const matchedKeys = new Set();
    if (application.documents) {
      Object.entries(application.documents).forEach(([key, doc]) => {
        const k = String(key || '');
        if (k.includes('patient') && (k.includes('Aadhar') || k.includes('Pan') || k.includes('Address'))) {
          documentCategories['Patient KYC'].push({ key, ...doc });
          matchedKeys.add(key);
        } else if (k.includes('policyHolder') && (k.includes('Aadhar') || k.includes('Pan') || k.includes('Address'))) {
          documentCategories['Policy Holder KYC'].push({ key, ...doc });
          matchedKeys.add(key);
        } else if (k.includes('policy')) {
          documentCategories['Policy Documents'].push({ key, ...doc });
          matchedKeys.add(key);
        } else if (k.includes('medicalHistory')) {
          documentCategories['Medical History'].push({ key, ...doc });
          matchedKeys.add(key);
        } else if (k.includes('treatment')) {
          documentCategories['Treatment Documents'].push({ key, ...doc });
          matchedKeys.add(key);
        }
      });
    }

    // Capture any remaining application documents that didn't match above groups
    const otherDocs = [];
    if (application.documents) {
      Object.entries(application.documents).forEach(([key, doc]) => {
        if (!matchedKeys.has(key)) otherDocs.push({ key, ...doc });
      });
    }

    // Include ALL uploaded docs beyond application.documents for full visibility
    const dischargeDocs = Array.isArray(application?.dischargeDocuments) ? application.dischargeDocuments : [];
    const dispatchDocs = Array.isArray(application?.dispatchDocuments) ? application.dispatchDocuments : [];
    const settlementDocs = Array.isArray(application?.workflow?.dischargeSettlement?.uploadedDocuments)
      ? application.workflow.dischargeSettlement.uploadedDocuments
      : [];

    // Total count across all known sources
    const totalDocsCount = (
      Object.keys(application.documents || {}).length +
      dischargeDocs.length +
      dispatchDocs.length +
      settlementDocs.length
    );

    return (
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-semibold text-gray-900">Application Documents</h2>
          <div className="text-sm text-gray-600">
            {totalDocsCount} document(s) uploaded
          </div>
        </div>

        {Object.entries(documentCategories).map(([category, docs]) => (
          docs.length > 0 && (
            <div key={category} className="bg-white rounded-lg border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
                <ClipboardList className="h-5 w-5 text-gray-600" />
                <span>{category}</span>
                <span className="text-sm font-normal text-gray-500">({docs.length})</span>
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {docs.map((doc) => {
                  const queries = documentQueries[doc.key] || [];
                  const openQueries = queries.filter(q => q.status === 'open');
                  return (
                  <div key={doc.key} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex items-center space-x-2 flex-1 min-w-0">
                        <FileText className="h-5 w-5 text-blue-500 flex-shrink-0" />
                        <div className="min-w-0 flex-1">
                          <h4 className="font-medium text-gray-900 text-sm">
                            {doc.key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                          </h4>
                          {openQueries.length > 0 && (
                            <div className="mt-1">
                              <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-yellow-100 text-yellow-800">
                                {openQueries.length} {openQueries.length === 1 ? 'query' : 'queries'}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="flex items-center space-x-1 flex-shrink-0">
                        {queries.length > 0 && (
                          <button
                            onClick={() => setQueryDetailsModal({ docKey: doc.key, queries })}
                            className="text-orange-600 hover:text-orange-800 p-1"
                            title="View Queries"
                          >
                            <MessageCircle className="h-4 w-4" />
                          </button>
                        )}
                        <button
                          onClick={() => openDocument(doc)}
                          className="text-blue-600 hover:text-blue-800 p-1"
                          title="View Document"
                        >
                          <Eye className="h-4 w-4" />
                        </button>
                        <button
                          onClick={() => downloadFile(doc.url, doc.fileName)}
                          className="text-green-600 hover:text-green-800 p-1"
                          title="Download Document"
                        >
                          <Download className="h-4 w-4" />
                        </button>
                      </div>
                    </div>

                    <div className="text-sm text-gray-600 space-y-1">
                      <p className="truncate">{doc.fileName}</p>
                      {typeof doc.size === 'number' && <p>Size: {(doc.size / 1024).toFixed(1)} KB</p>}
                      {doc.uploadedAt && <p>Uploaded: {formatDate(doc.uploadedAt)}</p>}
                    </div>
                  </div>
                );
              })}
              </div>
            </div>
          )
        ))}

        {/* Other Documents (uncategorized) */}
        {otherDocs.length > 0 && (
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
              <ClipboardList className="h-5 w-5 text-gray-600" />
              <span>Other Documents</span>
              <span className="text-sm font-normal text-gray-500">({otherDocs.length})</span>
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {otherDocs.map((doc) => {
                const queries = documentQueries[doc.key] || [];
                const openQueries = queries.filter(q => q.status === 'open');
                const displayName = doc.key?.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()) || (doc.fileName || 'Document');
                return (
                  <div key={doc.key} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex items-center space-x-2 flex-1 min-w-0">
                        <FileText className="h-5 w-5 text-blue-500 flex-shrink-0" />
                        <div className="min-w-0 flex-1">
                          <h4 className="font-medium text-gray-900 text-sm truncate">{displayName}</h4>
                          {openQueries.length > 0 && (
                            <div className="mt-1">
                              <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-yellow-100 text-yellow-800">
                                {openQueries.length} {openQueries.length === 1 ? 'query' : 'queries'}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="flex items-center space-x-1 flex-shrink-0">
                        {queries.length > 0 && (
                          <button
                            onClick={() => setQueryDetailsModal({ docKey: doc.key, queries })}
                            className="text-orange-600 hover:text-orange-800 p-1"
                            title="View Queries"
                          >
                            <MessageCircle className="h-4 w-4" />
                          </button>
                        )}
                        <button
                          onClick={() => openDocument(doc)}
                          className="text-blue-600 hover:text-blue-800 p-1"
                          title="View Document"
                        >
                          <Eye className="h-4 w-4" />
                        </button>
                        <button
                          onClick={() => downloadFile(doc.url, doc.fileName)}
                          className="text-green-600 hover:text-green-800 p-1"
                          title="Download Document"
                        >
                          <Download className="h-4 w-4" />
                        </button>
                      </div>
                    </div>
                    <div className="text-sm text-gray-600 space-y-1">
                      <p className="truncate">{doc.fileName}</p>
                      {typeof doc.size === 'number' && <p>Size: {(doc.size / 1024).toFixed(1)} KB</p>}
                      {doc.uploadedAt && <p>Uploaded: {formatDate(doc.uploadedAt)}</p>}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Discharge Documents */}
        {dischargeDocs.length > 0 && (
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
              <ClipboardList className="h-5 w-5 text-gray-600" />
              <span>Discharge Documents</span>
              <span className="text-sm font-normal text-gray-500">({dischargeDocs.length})</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {dischargeDocs.map((d, idx) => {
                const displayName = d.title || d.type || d.fileName || getNameFromUrl(d.url || '') || `Discharge Document ${idx + 1}`;
                const fileName = d.fileName || displayName;
                return (
                  <div key={`dis-${idx}-${fileName}`} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex items-center space-x-2 flex-1 min-w-0">
                        <FileText className="h-5 w-5 text-blue-500 flex-shrink-0" />
                        <div className="min-w-0 flex-1">
                          <h4 className="font-medium text-gray-900 text-sm truncate">{displayName}</h4>
                          {d.description && <p className="text-xs text-gray-600 mt-0.5 truncate">{d.description}</p>}
                        </div>
                      </div>
                      <div className="flex items-center space-x-1 flex-shrink-0">
                        <button onClick={() => openDocument({ url: d.url, fileName })} className="text-blue-600 hover:text-blue-800 p-1" title="View">
                          <Eye className="h-4 w-4" />
                        </button>
                        <button onClick={() => downloadFile(d.url, fileName)} className="text-green-600 hover:text-green-800 p-1" title="Download">
                          <Download className="h-4 w-4" />
                        </button>
                      </div>
                    </div>
                    <div className="text-sm text-gray-600 space-y-1">
                      <p className="truncate">{fileName}</p>
                      {typeof d.size === 'number' && <p>Size: {(d.size / 1024).toFixed(1)} KB</p>}
                      {d.uploadedAt && <p>Uploaded: {formatDate(d.uploadedAt)}</p>}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Settlement Documents (doctor uploaded during scrutiny) */}
        {settlementDocs.length > 0 && (
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
              <ClipboardList className="h-5 w-5 text-gray-600" />
              <span>Settlement Documents</span>
              <span className="text-sm font-normal text-gray-500">({settlementDocs.length})</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {settlementDocs.map((d, idx) => {
                const displayName = d.title || d.type || d.fileName || getNameFromUrl(d.url || '') || `Settlement Document ${idx + 1}`;
                const fileName = d.fileName || displayName;
                return (
                  <div key={`set-${idx}-${fileName}`} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex items-center space-x-2 flex-1 min-w-0">
                        <FileText className="h-5 w-5 text-blue-500 flex-shrink-0" />
                        <div className="min-w-0 flex-1">
                          <h4 className="font-medium text-gray-900 text-sm truncate">{displayName}</h4>
                          {d.description && <p className="text-xs text-gray-600 mt-0.5 truncate">{d.description}</p>}
                        </div>
                      </div>
                      <div className="flex items-center space-x-1 flex-shrink-0">
                        <button onClick={() => openDocument({ url: d.url, fileName })} className="text-blue-600 hover:text-blue-800 p-1" title="View">
                          <Eye className="h-4 w-4" />
                        </button>
                        <button onClick={() => downloadFile(d.url, fileName)} className="text-green-600 hover:text-green-800 p-1" title="Download">
                          <Download className="h-4 w-4" />
                        </button>
                      </div>
                    </div>
                    <div className="text-sm text-gray-600 space-y-1">
                      <p className="truncate">{fileName}</p>
                      {typeof d.size === 'number' && <p>Size: {(d.size / 1024).toFixed(1)} KB</p>}
                      {d.uploadedAt && <p>Uploaded: {formatDate(d.uploadedAt)}</p>}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Dispatch Documents */}
        {dispatchDocs.length > 0 && (
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
              <ClipboardList className="h-5 w-5 text-gray-600" />
              <span>Dispatch Documents</span>
              <span className="text-sm font-normal text-gray-500">({dispatchDocs.length})</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {dispatchDocs.map((d, idx) => {
                const displayName = d.title || d.type || d.fileName || getNameFromUrl(d.url || '') || `Dispatch Document ${idx + 1}`;
                const fileName = d.fileName || displayName;
                return (
                  <div key={`disp-${idx}-${fileName}`} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex items-center space-x-2 flex-1 min-w-0">
                        <FileText className="h-5 w-5 text-blue-500 flex-shrink-0" />
                        <div className="min-w-0 flex-1">
                          <h4 className="font-medium text-gray-900 text-sm truncate">{displayName}</h4>
                          {d.description && <p className="text-xs text-gray-600 mt-0.5 truncate">{d.description}</p>}
                        </div>
                      </div>
                      <div className="flex items-center space-x-1 flex-shrink-0">
                        <button onClick={() => openDocument({ url: d.url, fileName })} className="text-blue-600 hover:text-blue-800 p-1" title="View">
                          <Eye className="h-4 w-4" />
                        </button>
                        <button onClick={() => downloadFile(d.url, fileName)} className="text-green-600 hover:text-green-800 p-1" title="Download">
                          <Download className="h-4 w-4" />
                        </button>
                      </div>
                    </div>
                    <div className="text-sm text-gray-600 space-y-1">
                      <p className="truncate">{fileName}</p>
                      {typeof d.size === 'number' && <p>Size: {(d.size / 1024).toFixed(1)} KB</p>}
                      {d.uploadedAt && <p>Uploaded: {formatDate(d.uploadedAt)}</p>}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {totalDocsCount === 0 && (
          <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
            <FileText className="h-12 w-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">No Documents</h3>
            <p className="text-gray-600">No documents have been uploaded for this application.</p>
          </div>
        )}
      </div>
    );
  };

  const renderStatusTimeline = () => {
    // Derived flags to prevent misleading statuses after KYP revision
    const kypApprovalStatus = application.workflow?.medicalVerification?.kypApproval?.status;
    const isKypApprovedByDoctor = kypApprovalStatus === 'approved';
    const reassign = application.workflow?.medicalVerification?.kypReassignment;
    const reassignTargets = reassign?.targets || (reassign?.target ? [reassign.target] : []);
    const reassignIncludesPolicy = reassignTargets.includes('policy') || reassign?.target === 'policy' || reassign?.target === 'both';
    const policyReassignCompleted = reassignIncludesPolicy && ['policy_completed', 'completed'].includes(reassign?.status);

    const policyBaseApproved = application.workflow?.policyVerification?.status === 'approved';
    const policyBaseRejected = application.workflow?.policyVerification?.status === 'rejected';
    const policyDerivedApproved = policyBaseApproved || isKypApprovedByDoctor || policyReassignCompleted;

    const statusHistory = [
      {
        status: 'submitted',
        title: 'Application Submitted',
        description: 'Hospital submitted the patient application',
        timestamp: application.submittedAt,
        completed: true,
        icon: FileText,
        color: 'blue'
      },
      {
        status: 'medical_review',
        title: 'Medical Review',
        description: 'Medical team reviewing patient documents',
        timestamp: application.workflow?.medicalVerification?.verifiedAt,
        completed: application.workflow?.medicalVerification?.status === 'approved',
        icon: Stethoscope,
        color: 'green'
      },
      {
        status: 'policy_review',
        title: 'Policy Verification',
        description: 'Policy team verifying insurance details',
        timestamp: application.workflow?.policyVerification?.verifiedAt,
        completed: policyDerivedApproved,
        icon: Shield,
        color: 'purple'
      },
      {
        status: 'kyc_verification',
        title: 'KYC Verification',
        description: 'Patient identity and documents verification',
        timestamp: application.workflow?.kycVerification?.verifiedAt,
        completed: application.workflow?.kycVerification?.status === 'approved',
        icon: User,
        color: 'orange'
      },
      {
        status: 'approved',
        title: 'Application Approved',
        description: 'Application approved for processing',
        timestamp: application.approvedAt,
        completed: application.status === 'approved',
        icon: CheckCircle,
        color: 'green'
      }
    ];

    return (
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-semibold text-gray-900">Application Status Timeline</h2>
          <span className={`px-3 py-1 rounded-full text-sm font-medium border ${getStatusColor(application.status)}`}>
            {application.status?.replace('_', ' ').charAt(0).toUpperCase() + application.status?.replace('_', ' ').slice(1)}
          </span>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <div className="space-y-6">
            {statusHistory.map((item, index) => {
              const Icon = item.icon;
              const isActive = index === statusHistory.findIndex(s => !s.completed);
              const isCompleted = item.completed;

              return (
                <div key={item.status} className="relative">
                  {index < statusHistory.length - 1 && (
                    <div className={`absolute left-4 top-8 w-0.5 h-12 ${isCompleted ? 'bg-green-300' : 'bg-gray-200'
                      }`} />
                  )}

                  <div className="flex items-start space-x-4">
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${isCompleted
                        ? 'bg-green-100 border-green-500'
                        : isActive
                          ? 'bg-yellow-100 border-yellow-500'
                          : 'bg-gray-100 border-gray-300'
                      }`}>
                      <Icon className={`h-4 w-4 ${isCompleted
                          ? 'text-green-600'
                          : isActive
                            ? 'text-yellow-600'
                            : 'text-gray-400'
                        }`} />
                    </div>

                    <div className="flex-1">
                      <div className="flex items-center justify-between">
                        <h3 className={`font-medium ${isCompleted ? 'text-gray-900' : isActive ? 'text-gray-900' : 'text-gray-500'
                          }`}>
                          {item.title}
                        </h3>
                        {item.timestamp && (
                          <span className="text-sm text-gray-500">
                            {formatDate(item.timestamp)}
                          </span>
                        )}
                      </div>
                      <p className={`text-sm ${isCompleted ? 'text-gray-600' : isActive ? 'text-gray-600' : 'text-gray-400'
                        }`}>
                        {item.description}
                      </p>

                      {/* Workflow comments */}
                      {item.status === 'medical_review' && application.workflow?.medicalVerification?.comments && (
                        <div className="mt-2 p-2 bg-green-50 rounded border border-green-200">
                          <p className="text-sm text-green-800">{application.workflow.medicalVerification.comments}</p>
                        </div>
                      )}

                      {item.status === 'policy_review' && application.workflow?.policyVerification?.comments && (
                        <div className="mt-2 p-2 bg-purple-50 rounded border border-purple-200">
                          <p className="text-sm text-purple-800">{application.workflow.policyVerification.comments}</p>
                        </div>
                      )}

                      {item.status === 'kyc_verification' && application.workflow?.kycVerification?.comments && (
                        <div className="mt-2 p-2 bg-orange-50 rounded border border-orange-200">
                          <p className="text-sm text-orange-800">{application.workflow.kycVerification.comments}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Current Status Details */}
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Current Status Details</h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className={`inline-flex p-3 rounded-full mb-2 ${application.workflow?.medicalVerification?.status === 'approved'
                  ? 'bg-green-100'
                  : application.workflow?.medicalVerification?.status === 'rejected'
                    ? 'bg-red-100'
                    : 'bg-yellow-100'
                }`}>
                <Stethoscope className={`h-6 w-6 ${application.workflow?.medicalVerification?.status === 'approved'
                    ? 'text-green-600'
                    : application.workflow?.medicalVerification?.status === 'rejected'
                      ? 'text-red-600'
                      : 'text-yellow-600'
                  }`} />
              </div>
              <h4 className="font-medium text-gray-900">Medical Review</h4>
              <p className="text-sm text-gray-600">
                {application.workflow?.medicalVerification?.status === 'approved'
                  ? 'Approved'
                  : application.workflow?.medicalVerification?.status === 'rejected'
                    ? 'Rejected'
                    : 'Pending Review'}
              </p>
            </div>

            <div className="text-center">
              <div className={`inline-flex p-3 rounded-full mb-2 ${policyDerivedApproved
                  ? 'bg-green-100'
                  : application.workflow?.policyVerification?.status === 'rejected'
                    ? 'bg-red-100'
                    : 'bg-yellow-100'
                }`}>
                <Shield className={`h-6 w-6 ${policyDerivedApproved
                    ? 'text-green-600'
                    : application.workflow?.policyVerification?.status === 'rejected'
                      ? 'text-red-600'
                      : 'text-yellow-600'
                  }`} />
              </div>
              <h4 className="font-medium text-gray-900">Policy Review</h4>
              <p className="text-sm text-gray-600">
                {policyDerivedApproved
                  ? (policyBaseApproved ? 'Approved' : 'Approved (via revised KYP)')
                  : policyBaseRejected
                    ? 'Rejected'
                    : 'Pending Review'}
              </p>
            </div>

            <div className="text-center">
              <div className={`inline-flex p-3 rounded-full mb-2 ${application.workflow?.kycVerification?.status === 'approved'
                  ? 'bg-green-100'
                  : application.workflow?.kycVerification?.status === 'rejected'
                    ? 'bg-red-100'
                    : 'bg-yellow-100'
                }`}>
                <User className={`h-6 w-6 ${application.workflow?.kycVerification?.status === 'approved'
                    ? 'text-green-600'
                    : application.workflow?.kycVerification?.status === 'rejected'
                      ? 'text-red-600'
                      : 'text-yellow-600'
                  }`} />
              </div>
              <h4 className="font-medium text-gray-900">KYC Verification</h4>
              <p className="text-sm text-gray-600">
                {application.workflow?.kycVerification?.status === 'approved'
                  ? 'Approved'
                  : application.workflow?.kycVerification?.status === 'rejected'
                    ? 'Rejected'
                    : 'Pending Review'}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render Discharge Process tab (visible after KYP letter is generated)
  const renderDischargeProcess = () => {
    const suggestions = DISCHARGE_TYPE_SUGGESTIONS;

    const docs = application?.dischargeDocuments || [];
    const dispatchDocs = application?.dispatchDocuments || [];

    // Debug logging to help troubleshoot data loading issues
    console.log('Discharge Process Debug:', {
      applicationId: application?.applicationId,
      dischargeDocuments: docs,
      dispatchDocuments: dispatchDocs,
      docsLength: docs.length,
      dispatchDocsLength: dispatchDocs.length
    });
    // Doctor dispatch start approval and approved-docs gating
    const dispatchClearance = application?.workflow?.dischargeSettlement?.dispatchClearance || null;
    const isDispatchApprovedByDoctor = dispatchClearance?.status === 'approved';
    const dispatchReview = application?.workflow?.dischargeSettlement?.dispatchReview || null;
    const isDispatchReviewRequested = dispatchReview?.status === 'requested';
    // Consider approvals across BOTH Scrutiny (discharge) and Dispatch uploads
    const hasAnyApprovedDoc = [...(docs || []), ...(dispatchDocs || [])].some((d) => d.dispatchStatus === 'approved');
    // Count approved docs included in the bundle (for UX transparency)
    const approvedCount = [...(docs || []), ...(dispatchDocs || [])].filter((d) => d.dispatchStatus === 'approved').length;
    const pvDispatchAddr = application?.workflow?.policyVerification?.dispatchAddress || null;
    // Scrutiny gating (approved when checker_confirmed or explicit approval flag present)
    const scrutinyReview = application?.workflow?.dischargeSettlement?.scrutinyReview || null;
    const isScrutinyCleared = Boolean(scrutinyReview?.status === 'checker_confirmed' || application?.workflow?.dischargeSettlement?.scrutinyApproval?.status === 'approved');
    // Simplify gating: allow dispatch UI and bundle when doctor has approved dispatch start and at least one doc is approved
    // Simplify: show dispatch flow after FAL acceptance; proceed when a bundle exists (hasAnyApprovedDoc)
    const canShowDispatch = Boolean(isFALAcceptedByHospital);
    // New gating: show Scrutiny Documents only after FAL is approved/published by the doctor
    // Doctor approval publishes a quicklink into application at workflow.dischargeSettlement.finalApprovalLetterUrl
    const isFALDoctorApproved = Boolean(application?.workflow?.dischargeSettlement?.finalApprovalLetterUrl);

    // Download all approved-for-dispatch documents as single PDF
    const downloadApprovedBundle = async () => {
      try {
        // Scrutiny clearance no longer blocks bundle download; doctor approval + any approved doc is sufficient
        setBundleDownloading(true);
        const res = await getApprovedDispatchDocuments(application.applicationId);
        if (!res.success) throw new Error(res.error || 'Failed to get approved documents');
        const approved = res.documents || [];
        if (approved.length === 0) {
          alert('No documents approved by doctor for dispatch yet');
          return;
        }
        const blob = await mergeDocumentsToPdf(approved, { title: `Dispatch Documents • ${application.applicationId}` });
        downloadBlob(blob, `Dispatch_${application.applicationId}.pdf`);
      } catch (e) {
        console.error('Bundle download error:', e);
        alert(e.message || 'Failed to prepare bundle');
      } finally {
        setBundleDownloading(false);
      }
    };

    const accept = '.pdf,.jpg,.jpeg,.png';

    // Separate Dispatch Documents upload handlers (state defined at top-level)
    const onDispatchDocsUpload = async () => {
      setDispatchUploadError('');
      if (!dispatchUpload?.file || !dispatchUpload?.title || !dispatchUpload?.type) {
        setDispatchUploadError('Please choose a file and enter both title and type');
        return;
      }
      // Enforce max 100 MB per file
      const MAX_MB = 100;
      const MAX_BYTES = MAX_MB * 1024 * 1024;
      if (dispatchUpload.file.size > MAX_BYTES) {
        setDispatchUploadError(`File too large. Maximum allowed size is ${MAX_MB} MB.`);
        return;
      }
      try {
        setUploadingDispatchDocs(true);
        const { uploadDispatchDocument } = await import('../../services/applicationService');
        const res = await uploadDispatchDocument(
          application.applicationId,
          dispatchUpload.file,
          dispatchUpload.title,
          { uploadedBy: 'hospital', uploaderName: application.hospitalName || 'Hospital', description: dispatchUpload.description || '', type: dispatchUpload.type }
        );
        if (!res.success) throw new Error(res.error || `Failed to upload ${dispatchUpload.file.name}`);
        // Clear the upload form first
        setDispatchUpload({ file: null, type: '', title: '', description: '' });
        // Reload application data from server to ensure consistency and avoid duplicates
        await loadApplicationData();
        // Refresh dispatches list (separate subcollection)
        await loadDispatches();
      } catch (e) {
        setDispatchUploadError(e.message || 'Upload failed');
      } finally {
        setUploadingDispatchDocs(false);
      }
    };

    // Scrutiny helpers removed: New scrutiny UI directly shows existing docs and allows upload/replace per item.

    // New: add files to batch selection
    const handleAddFiles = (files) => {
      const newItems = Array.from(files || []).map((file) => ({
        file,
        type: '',
        description: ''
      }));
      setSelectedDischargeItems((prev) => [...prev, ...newItems]);
    };

    const handleUpdateItem = (index, patch) => {
      setSelectedDischargeItems((prev) => prev.map((it, i) => (i === index ? { ...it, ...patch } : it)));
    };

    const removeItem = (index) => {
      setSelectedDischargeItems((prev) => prev.filter((_, i) => i !== index));
    };

    const clearBatch = () => setSelectedDischargeItems([]);

    const canBatchUpload = selectedDischargeItems.length > 0 && selectedDischargeItems.every((it) => it.type && it.file);

    const onBatchUpload = async () => {
      setUploadError('');
      if (!canBatchUpload) {
        setUploadError('Please select type for each file');
        return;
      }
      try {
        setUploadingDischarge(true);
        const uploadedDocs = [];
        for (const item of selectedDischargeItems) {
          const res = await uploadDischargeDocument(
            application.applicationId,
            item.file,
            item.type,
            {
              uploadedBy: 'hospital',
              uploaderName: application.hospitalName || 'Hospital',
              description: item.description || ''
            }
          );
          if (!res.success) throw new Error(res.error || `Failed to upload ${item.file.name}`);
          if (res.document) uploadedDocs.push(res.document);
        }
        // Clear batch first to avoid UI confusion
        clearBatch();
        // Reload application data from server to ensure consistency and avoid duplicates
        await loadApplicationData();
      } catch (e) {
        setUploadError(e.message || 'Batch upload failed');
      } finally {
        setUploadingDischarge(false);
      }
    };

    // Removed itemized dispatch selection; dispatch uses the approved bundle

    const handleDispatchSubmit = async () => {
      if (!dispatchForm.dispatchedAt) {
        alert('Please provide dispatch date & time');
        return;
      }
      // Ensure at least one dispatch document (e.g., the uploaded Approved Scrutiny Bundle) is present
      const uploadedDispatchDocs = Array.isArray(application?.dispatchDocuments) ? application.dispatchDocuments : [];
      if (uploadedDispatchDocs.length === 0) {
        alert('Please upload at least one dispatch document (e.g., the Approved Scrutiny Bundle) before submitting.');
        return;
      }
      setDispatching(true);
      try {
        // Optional POD file upload if provided
        let podMeta = null;
        if (dispatchForm.podFile && dispatchForm.podFile instanceof File) {
          try {
            const { uploadFile } = await import('../../services/fileUploadService');
            const time = Date.now();
            const safeName = (dispatchForm.podFile.name || 'POD').replace(/[^a-zA-Z0-9._-]/g, '_');
            const storagePath = `dispatches/${application.applicationId}/${time}_${Math.random().toString(36).slice(2, 8)}_${safeName}`;
            const uploaded = await uploadFile(dispatchForm.podFile, storagePath);
            podMeta = {
              url: uploaded.downloadURL,
              name: uploaded.metadata?.name || dispatchForm.podFile.name,
              size: uploaded.metadata?.size || dispatchForm.podFile.size,
              type: uploaded.metadata?.type || dispatchForm.podFile.type,
              uploadedAt: uploaded.metadata?.uploadedAt || new Date().toISOString(),
              uploadedBy: 'hospital',
              uploaderName: application.hospitalName || 'Hospital',
              storagePath: uploaded.metadata?.fullPath
            };
          } catch (e) {
            console.error('POD upload failed', e);
            alert('POD upload failed, please try again or proceed without POD');
          }
        }
        // Include all uploaded dispatch documents in the dispatch record payload
        const payload = {
          documents: uploadedDispatchDocs.map(d => ({ id: d.id, title: d.title || d.fileName || 'Document', url: d.url, type: d.type || 'document', fileName: d.fileName })),
          mode: dispatchForm.mode,
          dispatchedAt: dispatchForm.dispatchedAt,
          trackingId: dispatchForm.trackingId,
          notes: dispatchForm.notes,
          pod: podMeta,
          createdBy: 'hospital'
        };
        const res = await createDocumentDispatch(application.applicationId, payload);
        if (res.success) {
          setDispatchForm({ mode: 'Courier', dispatchedAt: '', trackingId: '', notes: '', podFile: null });
          await loadDispatches();
          alert('Dispatch recorded successfully');
        } else {
          alert(res.error || 'Failed to create dispatch');
        }
      } catch (e) {
        console.error('Error creating dispatch', e);
        alert('Error creating dispatch');
      } finally {
        setDispatching(false);
      }
    };

    // Send uploaded docs for doctor's review (sets a reviewRequested flag and optional note)
    // Open/close review confirmation
    const openReviewConfirm = () => setShowReviewConfirm(true);
    const closeReviewConfirm = () => setShowReviewConfirm(false);

    return (
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-semibold text-gray-900">Discharge Process</h2>
          <div className="flex items-center space-x-4">
            <button
              onClick={async () => {
                setRefreshingDischargeData(true);
                try {
                  await Promise.all([
                    loadApplicationData(),
                    loadDispatches(),
                    loadDischargeItems()
                  ]);
                } finally {
                  setRefreshingDischargeData(false);
                }
              }}
              className="flex items-center px-3 py-2 text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-md transition-colors"
              disabled={refreshingDischargeData}
            >
              <RefreshCw className={`h-4 w-4 mr-2 ${refreshingDischargeData ? 'animate-spin' : ''}`} />
              Refresh Data
            </button>
            <span className="text-sm text-gray-600">
              Upload final discharge documents. {isFALAcceptedByHospital ? 'Dispatch uses the Approved Scrutiny Bundle. You can submit dispatch details once ready.' : 'Dispatch will be enabled after Final Approval Letter is accepted.'}
            </span>
          </div>
        </div>

        {/* Discharge Items Summary (Read-only) */}
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-3">
            <h3 className="text-lg font-semibold text-gray-900">Discharge Items Summary</h3>
            {loadingDischargeItems && (
              <span className="text-sm text-gray-500 flex items-center"><Loader className="h-4 w-4 animate-spin mr-2" />Loading…</span>
            )}
          </div>
          <p className="text-sm text-gray-600 mb-4">Below are the line items added by the medical team with eligibility, payable type, and reasons for any deductions/non-payables.</p>
          {dischargeItems.length === 0 ? (
            <div className="text-sm text-gray-600">No items available yet.</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-2 text-left text-xs font-semibold text-gray-600">Item</th>
                    <th className="px-4 py-2 text-left text-xs font-semibold text-gray-600">Category</th>
                    <th className="px-4 py-2 text-right text-xs font-semibold text-gray-600">Qty</th>
                    <th className="px-4 py-2 text-right text-xs font-semibold text-gray-600">Unit Rate</th>
                    <th className="px-4 py-2 text-right text-xs font-semibold text-gray-600">Eligible Unit</th>
                    <th className="px-4 py-2 text-right text-xs font-semibold text-gray-600">Billed</th>
                    <th className="px-4 py-2 text-right text-xs font-semibold text-gray-600">Eligible</th>
                    <th className="px-4 py-2 text-left text-xs font-semibold text-gray-600">Type</th>
                    <th className="px-4 py-2 text-left text-xs font-semibold text-gray-600">Remarks / Reason</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {dischargeItems.map((it, idx) => (
                    <tr key={it.id || idx} className="hover:bg-gray-50">
                      <td className="px-4 py-2 text-sm text-gray-900 font-medium">{it.itemName || '-'}</td>
                      <td className="px-4 py-2 text-sm text-gray-700">{it.category || '-'}</td>
                      <td className="px-4 py-2 text-sm text-gray-700 text-right">{it.quantity ?? '-'}</td>
                      <td className="px-4 py-2 text-sm text-gray-700 text-right">₹{Number(it.unitRate || 0).toLocaleString('en-IN')}</td>
                      <td className="px-4 py-2 text-sm text-gray-700 text-right">₹{Number(it.eligibleUnitRate || 0).toLocaleString('en-IN')}</td>
                      <td className="px-4 py-2 text-sm text-gray-900 text-right font-medium">₹{Number(it.billedAmount || 0).toLocaleString('en-IN')}</td>
                      <td className="px-4 py-2 text-sm text-gray-900 text-right font-medium">₹{Number(it.eligibleAmount || 0).toLocaleString('en-IN')}</td>
                      <td className="px-4 py-2 text-sm">
                        <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${(it.payableType === 'non_payable')
                            ? 'bg-red-100 text-red-800 border border-red-200'
                            : (it.payableType === 'deduction')
                              ? 'bg-yellow-100 text-yellow-800 border border-yellow-200'
                              : 'bg-green-100 text-green-800 border border-green-200'
                          }`}>
                          {it.payableType === 'non_payable' ? 'Non‑Payable' : it.payableType === 'deduction' ? 'Deduction' : 'Payable'}
                        </span>
                      </td>
                      <td className="px-4 py-2 text-sm">
                        {(it.payableType === 'non_payable' || it.payableType === 'deduction') ? (
                          <span className="text-red-700">{it.remarks || '-'}</span>
                        ) : (
                          <span className="text-gray-600">{it.remarks || '-'}</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot className="bg-gray-50">
                  <tr>
                    <td className="px-4 py-2 text-sm font-semibold text-gray-700" colSpan={5}>Totals</td>
                    <td className="px-4 py-2 text-sm font-semibold text-gray-900 text-right">₹{dischargeItems.reduce((s, it) => s + (Number(it.billedAmount) || 0), 0).toLocaleString('en-IN')}</td>
                    <td className="px-4 py-2 text-sm font-semibold text-gray-900 text-right">₹{dischargeItems.reduce((s, it) => s + (Number(it.eligibleAmount) || 0), 0).toLocaleString('en-IN')}</td>
                    <td className="px-4 py-2" colSpan={2}></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>

        {/* Admission and Discharge Dates with gating (hidden after FAL doctor approval) */}
        {!isFALDoctorApproved && (
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Patient Stay Information</h3>
              {!stayDatesConfirmed ? (
                <span className="text-xs px-2 py-1 rounded-full bg-yellow-100 text-yellow-800 border border-yellow-200">Action Required</span>
              ) : (
                <span className="text-xs px-2 py-1 rounded-full bg-green-100 text-green-800 border border-green-200">Confirmed</span>
              )}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Admission Date
                </label>
                <input
                  type="date"
                  value={dischargeDates.admissionDate}
                  onChange={(e) => setDischargeDates(prev => ({
                    ...prev,
                    admissionDate: e.target.value
                  }))}
                  className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                />
                <p className="text-xs text-gray-500 mt-1">Pre-filled from application, you can modify if needed</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Discharge Date
                </label>
                <input
                  type="date"
                  value={dischargeDates.dischargeDate}
                  onChange={(e) => setDischargeDates(prev => ({
                    ...prev,
                    dischargeDate: e.target.value
                  }))}
                  className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                />
                <p className="text-xs text-gray-500 mt-1">Pre-filled from application, you can modify if needed</p>
              </div>
            </div>
            {/* Confirm/Save action */}
            <div className="mt-4 flex items-center justify-end gap-2">
              {!stayDatesConfirmed ? (
                <button
                  onClick={async () => {
                    try {
                      setStayDatesConfirming(true);
                      const { updatePatientStayDates } = await import('../../services/applicationService');
                      const res = await updatePatientStayDates(application.applicationId, {
                        admissionDate: dischargeDates.admissionDate || null,
                        dischargeDate: dischargeDates.dischargeDate || null
                      }, application.hospitalName || 'Hospital');
                      if (!res.success) throw new Error(res.error || 'Failed to confirm dates');
                      await loadApplicationData();
                      setStayDatesConfirmed(true);
                    } catch (e) {
                      alert(e.message || 'Failed to save dates');
                    } finally {
                      setStayDatesConfirming(false);
                    }
                  }}
                  className="bg-teal-600 text-white px-4 py-2 rounded-md hover:bg-teal-700 disabled:opacity-50"
                  disabled={stayDatesConfirming || !dischargeDates.admissionDate || !dischargeDates.dischargeDate}
                  title={!dischargeDates.admissionDate || !dischargeDates.dischargeDate ? 'Admission and discharge dates are required' : ''}
                >
                  {stayDatesConfirming ? 'Saving…' : 'Confirm Dates & Continue'}
                </button>
              ) : (
                <button
                  onClick={() => setStayDatesConfirmed(false)}
                  className="text-sm text-blue-600 hover:text-blue-800"
                  title="Edit dates"
                >
                  Edit Dates
                </button>
              )}
            </div>
          </div>
        )}

        {/* Batch selection and upload (hidden after FAL doctor approval) */}
        {!isFALDoctorApproved && (
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Batch Upload</h3>
              {selectedDischargeItems.length > 0 && (
                <button onClick={clearBatch} className="text-sm text-gray-600 hover:text-gray-800">Clear</button>
              )}
            </div>
            {!stayDatesConfirmed && (
              <div className="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded text-sm text-yellow-800">
                Please confirm the Admission and Discharge dates above to enable document uploads.
              </div>
            )}
            {/* Datalist for type suggestions */}
            <datalist id="discharge-title-suggestions">
              {suggestions.map((s) => (
                <option key={s} value={s} />
              ))}
            </datalist>
            <div className="grid grid-cols-1 gap-3">
              <div>
                <label className="text-sm font-medium text-gray-700">Choose Files</label>
                <input
                  type="file"
                  accept={accept}
                  multiple
                  onChange={(e) => { if (stayDatesConfirmed) handleAddFiles(e.target.files); }}
                  className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 bg-white"
                  disabled={!stayDatesConfirmed}
                />
                <p className="text-xs text-gray-500 mt-1">Select multiple files, then set type and optional description for each and upload all. Scrutiny approval is only required for bundling/dispatch, not for uploading.</p>
              </div>
              {selectedDischargeItems.length > 0 && (
                <div className="border border-gray-200 rounded-md divide-y">
                  {selectedDischargeItems.map((item, idx) => (
                    <div key={idx} className="p-3 flex flex-col md:flex-row md:items-end md:space-x-3 space-y-2 md:space-y-0">
                      <div className="flex-1">
                        <p className="text-sm text-gray-700 truncate">{item.file.name}</p>
                        <p className="text-xs text-gray-500">{(item.file.size / 1024).toFixed(1)} KB</p>
                      </div>
                      <div className="md:w-60">
                        <label className="text-xs font-medium text-gray-700">Type</label>
                        <input
                          list="discharge-title-suggestions"
                          value={item.type}
                          onChange={(e) => handleUpdateItem(idx, { type: e.target.value })}
                          placeholder="Select type"
                          className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                        />
                      </div>
                      <div className="md:flex-1">
                        <label className="text-xs font-medium text-gray-700">Description (optional)</label>
                        <input
                          value={item.description}
                          onChange={(e) => handleUpdateItem(idx, { description: e.target.value })}
                          placeholder="Add notes (optional)"
                          className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                        />
                      </div>
                      <div>
                        <button onClick={() => removeItem(idx)} className="text-sm text-red-600 hover:text-red-800">Remove</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <div className="flex justify-end">
                <button
                  onClick={onBatchUpload}
                  disabled={!canBatchUpload || uploadingDischarge}
                  className="bg-teal-600 text-white px-4 py-2 rounded-md hover:bg-teal-700 disabled:opacity-50"
                >
                  {uploadingDischarge ? 'Uploading...' : `Upload ${selectedDischargeItems.length || ''}`}
                </button>
              </div>
              {uploadError && selectedDischargeItems.length > 0 && (
                <p className="text-sm text-red-600">{uploadError}</p>
              )}
            </div>
          </div>
        )}

        {/* Documents List */}
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900">
              Uploaded Discharge Documents ({docs.length})
              {refreshingDischargeData && (
                <span className="ml-2 text-sm text-gray-500 flex items-center">
                  <Loader className="h-4 w-4 animate-spin mr-1" />
                  Refreshing...
                </span>
              )}
            </h3>
            <div className="flex items-center gap-2">
              {/* Initiate Discharge Button */}
              {docs.length > 0 && !application?.workflow?.dischargeSettlement?.dischargeInitiated?.status && (
                <button
                  onClick={async () => {
                    try {
                      const { initiateDischargeReview } = await import('../../services/applicationService');
                      const res = await initiateDischargeReview(application.applicationId, {
                        by: 'hospital',
                        byName: application.hospitalName || 'Hospital'
                      });
                      if (!res.success) throw new Error(res.error || 'Failed to initiate discharge');
                      await loadApplicationData();
                      alert('Discharge initiated successfully! Doctor team has been notified.');
                    } catch (e) {
                      alert(e.message || 'Failed to initiate discharge');
                    }
                  }}
                  className="text-sm bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 flex items-center gap-2"
                  title="Notify doctor team about discharge documents"
                >
                  <Bell className="h-4 w-4" />
                  Initiate Discharge
                </button>
              )}
              {docs.length > 0 && !application?.workflow?.dischargeSettlement?.dischargeInitiated?.status && (
                <p className="text-xs text-gray-600 italic ml-2">
                  💡 Once all documents are uploaded, click this button to initiate the discharge process and get final approval faster
                </p>
              )}
              {application?.workflow?.dischargeSettlement?.dischargeInitiated?.status === 'initiated' && (
                <div className="text-sm bg-green-50 border border-green-200 text-green-800 px-4 py-2 rounded-md flex items-center gap-2">
                  <CheckCircle className="h-4 w-4" />
                  <span>Discharge Initiated</span>
                </div>
              )}
              {/* <button onClick={downloadApprovedBundle} disabled={!hasAnyApprovedDoc || bundleDownloading} className="text-sm bg-teal-600 text-white px-3 py-1.5 rounded-md hover:bg-teal-700 disabled:opacity-50 flex items-center gap-2" title={!hasAnyApprovedDoc ? 'No approved documents yet' : ''}>
                {bundleDownloading ? (
                  <>
                    <Loader className="h-3 w-3 animate-spin" /> Preparing…
                  </>
                ) : (
                  `Download Approved Scrutiny Bundle${approvedCount ? ` (${approvedCount} items)` : ''}`
                )}
              </button> */}
            </div>
          </div>
          {application?.workflow?.dischargeSettlement?.dischargeInitiated?.status === 'initiated' && (
            <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-md">
              <p className="text-sm text-blue-900">
                <strong>Discharge initiated</strong> on {formatDate(application.workflow.dischargeSettlement.dischargeInitiated.at)} by {application.workflow.dischargeSettlement.dischargeInitiated.byName || 'Hospital'}
                {' • '}{application.workflow.dischargeSettlement.dischargeInitiated.documentCount || 0} documents sent to doctor team
              </p>
            </div>
          )}
          {docs.length === 0 ? (
            <div className="text-center py-8">
              <FileIcon className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <p className="text-sm text-gray-600 mb-2">No discharge documents uploaded yet.</p>
              <p className="text-xs text-gray-500">Use the upload section above to add discharge documents.</p>
            </div>
          ) : (
            <div className="space-y-3">
              {docs.map((doc) => (
                <div key={doc.id || doc.url} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                  <div>
                    <p className="font-medium text-gray-900 flex items-center space-x-2">
                      <span>{doc.title || doc.fileName}</span>
                      {doc.dispatchStatus && (
                        <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${doc.dispatchStatus === 'approved' ? 'bg-green-100 text-green-800' : doc.dispatchStatus === 'rejected' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800'}`}>
                          {doc.dispatchStatus.charAt(0).toUpperCase() + doc.dispatchStatus.slice(1)} for Dispatch
                        </span>
                      )}
                    </p>
                    <p className="text-xs text-gray-600">Type: {doc.type || doc.title}</p>
                    {doc.description && (
                      <p className="text-xs text-gray-600">Note: {doc.description}</p>
                    )}
                    <p className="text-xs text-gray-600">Uploaded {formatDate(doc.uploadedAt)} by {doc.uploaderName || doc.uploadedBy || 'Hospital'} • {(doc.size ? (doc.size / 1024).toFixed(1) : '?')} KB</p>
                  </div>
                  <div className="flex items-center space-x-2">
                    <button
                      onClick={() => openDocument(doc)}
                      className="text-blue-600 hover:text-blue-800"
                      title="View"
                    >
                      <Eye className="h-4 w-4" />
                    </button>
                    <button
                      onClick={() => downloadFile(doc.url, doc.fileName || 'document')}
                      className="text-green-600 hover:text-green-800"
                      title="Download"
                    >
                      <Download className="h-4 w-4" />
                    </button>
                  </div>
                </div>
              ))}
              {/* Send for Review (hidden after FAL doctor approval) */}
              {!isFALDoctorApproved && (
                <div className="border-t border-gray-200 pt-4">
                  <div className="flex flex-col md:flex-row md:items-center md:space-x-3 space-y-2 md:space-y-0">
                    <input
                      type="text"
                      value={reviewNote}
                      onChange={(e) => setReviewNote(e.target.value)}
                      placeholder="Add note for doctor (optional)"
                      className="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm"
                    />
                    <button
                      onClick={openReviewConfirm}
                      disabled={reviewRequesting || docs.length === 0 || application?.workflow?.dischargeSettlement?.dispatchReview?.status === 'requested'}
                      className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 disabled:opacity-50"
                      title={
                        docs.length === 0
                          ? 'Upload documents first'
                          : application?.workflow?.dischargeSettlement?.dispatchReview?.status === 'requested'
                            ? 'Review already requested'
                            : ''
                      }
                    >
                      {reviewRequesting
                        ? 'Sending…'
                        : application?.workflow?.dischargeSettlement?.dispatchReview?.status === 'requested'
                          ? 'Review Requested'
                          : 'Send for Doctor Review'}
                    </button>
                  </div>
                  {application?.workflow?.dischargeSettlement?.dispatchReview?.status === 'requested' && (
                    <p className="mt-2 text-xs text-blue-700">Review requested on {formatDate(application.workflow.dischargeSettlement.dispatchReview.at)}{application.workflow.dischargeSettlement.dispatchReview.byName ? ` • by ${application.workflow.dischargeSettlement.dispatchReview.byName}` : ''}</p>
                  )}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Scrutiny Documents (New, structured) */}
        {!isFALDoctorApproved ? (
          <div className="bg-white rounded-lg border border-yellow-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Scrutiny Documents</h3>
            <p className="text-sm text-yellow-800">This section will be available once the Final Approval Letter is approved by the doctor.</p>
          </div>
        ) : (
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-2">
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Scrutiny Documents</h3>
                {application?.workflow?.dischargeSettlement?.scrutinySubmission?.status === 'submitted' && (
                  <p className="text-xs text-blue-700">Submitted for doctor review on {formatDate(application.workflow.dischargeSettlement.scrutinySubmission.at)}{application.workflow.dischargeSettlement.scrutinySubmission.byName ? ` • by ${application.workflow.dischargeSettlement.scrutinySubmission.byName}` : ''}</p>
                )}
              </div>
              <div className="flex items-center gap-2">
                <p className="text-xs text-gray-600">Uploads are grouped; use the info icon to see what each item means.</p>
                <button
                  onClick={downloadApprovedBundle}
                  disabled={!hasAnyApprovedDoc || bundleDownloading}
                  className="text-xs text-teal-700 hover:text-teal-900 disabled:opacity-50 flex items-center gap-1"
                  title={!hasAnyApprovedDoc ? 'No approved documents yet' : ''}
                >
                  {bundleDownloading ? (
                    <>
                      <Loader className="h-3 w-3 animate-spin" /> Preparing…
                    </>
                  ) : (
                    `Download Approved Scrutiny Bundle${approvedCount ? ` (${approvedCount} items)` : ''}`
                  )}
                </button>
                <button
                  onClick={async () => {
                    try {
                      const { submitScrutinyChecklist } = await import('../../services/applicationService');
                      const res = await submitScrutinyChecklist(application.applicationId, { by: 'hospital', byName: application.hospitalName || 'Hospital' });
                      if (!res.success) throw new Error(res.error || 'Failed to submit scrutiny');
                      await loadApplicationData();
                    } catch (e) {
                      alert(e.message || 'Failed to submit');
                    }
                  }}
                  disabled={application?.workflow?.dischargeSettlement?.scrutinySubmission?.status === 'submitted'}
                  className="text-xs bg-teal-600 text-white px-3 py-1.5 rounded-md hover:bg-teal-700 disabled:opacity-50"
                  title={application?.workflow?.dischargeSettlement?.scrutinySubmission?.status === 'submitted' ? 'Already sent to doctor' : 'Send all scrutiny docs to doctor for review'}
                >
                  {application?.workflow?.dischargeSettlement?.scrutinySubmission?.status === 'submitted' ? 'Sent to Doctor' : 'Send for Doctor Review'}
                </button>
              </div>
            </div>

            {(() => {
              const dischargeDocs = docs || [];
              const dispatchDocsLocal = dispatchDocs || [];
              // Include mapped documents from application.documents as candidates for matching
              const documentsMap = application?.documents || {};
              // Expand arrays inside documents map (e.g., policyHolderPolicyCopyDocs: [...])
              const mappedDocs = Object.entries(documentsMap).flatMap(([key, value]) => {
                const normalize = (d, idx = 0) => ({
                  id: d?.id || d?.docId || `docmap_${key}_${idx}`,
                  title: d?.title || (key || '').replace(/_/g, ' '),
                  type: d?.type || key || 'document',
                  fileName: d?.fileName || d?.title || key || 'document',
                  url: d?.url,
                  size: d?.size || 0,
                  uploadedAt: d?.uploadedAt || new Date(),
                  uploadedBy: d?.uploadedBy || 'hospital',
                  uploaderName: d?.uploaderName || 'Hospital',
                  contentType: d?.contentType || 'application/octet-stream',
                  source: 'documentsMap'
                });
                if (Array.isArray(value)) {
                  return value.filter(Boolean).map((d, idx) => normalize(d, idx));
                }
                if (value && typeof value === 'object') {
                  return [normalize(value, 0)];
                }
                return [];
              });
              const allDocs = [...dischargeDocs, ...dispatchDocsLocal, ...mappedDocs];

              const norm = (s = '') => (s || '').toString().toLowerCase();
              const matchesAny = (d, arr) => {
                const hay = norm(`${d.type || ''} ${d.title || ''} ${d.fileName || ''}`);
                return arr.some((kw) => hay.includes(kw));
              };

              // Build structured checklist from the provided specification
              // Track documents we have already displayed to avoid duplicate rendering across items
              const seenDocKeys = new Set();

              const docIdentity = (d) => (d?.id || d?.url || d?.fileName || JSON.stringify({ t: d?.title, s: d?.size }));

              const GROUPS = [
                {
                  id: 'non_med_mand',
                  title: 'Non-medical mandatory documents',
                  collapsed: false,
                  items: [
                    { key: 'claim_form_a', title: 'Claim Form Part A', mandatory: 'all', treatment: 'both', desc: 'Original Claim Form A duly completely filled and signed by the claimant/primary insured.', kws: ['claim form a', 'part a'] },
                    { key: 'claim_form_b', title: 'Claim Form Part B', mandatory: 'all', treatment: 'both', desc: 'Original Claim Form B duly completely filled and certified by the treating doctor.', kws: ['claim form b', 'part b'] },
                    { key: 'insurance_id', title: 'Insurance Member ID card / Policy copy', mandatory: 'all', treatment: 'both', desc: 'Copy of insurance ID card and copies of all the insurance policies (in case of retail policies).', kws: ['insurance id', 'member id', 'id card', 'member card', 'policy copy', 'policyholder policy copy', 'policy holder policy copy', 'patient policy copy', 'policy pdf', 'insurance policy', 'policyholderpolicycopy', 'policyholder_policy_copy', 'policy holder policy copy doc'] },
                    { key: 'photo_id', title: 'Insured & Patient Photo ID', mandatory: 'all', treatment: 'both', desc: 'Photo ID proof (Passport, Electoral ID, etc.).', kws: ['photo id', 'passport', 'voter', 'elector', 'aadhaar', 'aadhar', 'pan'] },
                    { key: 'kyc_docs', title: 'KYC Documents', mandatory: 'all', treatment: 'both', desc: 'Aadhaar, PAN or any valid address/identity proof for insured/policy holder.', kws: ['kyc', 'aadhaar', 'aadhar', 'pan', 'address proof', 'identity proof'] },
                    { key: 'employee_id', title: 'Employee ID (Corporate)', mandatory: 'all', treatment: 'both', desc: 'Employee ID proof for corporate policies.', kws: ['employee id', 'corporate id', 'employee card'] },
                    { key: 'bank_details', title: 'Bank Account Details', mandatory: 'all', treatment: 'both', desc: 'Cancelled cheque in name of primary insured or bank proof (statement/passbook) with account number/type and IFSC.', kws: ['cancelled cheque', 'cheque', 'bank details', 'bank statement', 'statement', 'passbook', 'ifsc', 'account number', 'account no'] },
                  ]
                },
                {
                  id: 'medical_mand',
                  title: 'Medical mandatory documents',
                  collapsed: false,
                  items: [
                    { key: 'final_bill_breakup', title: 'Original Final Bill with breakup', mandatory: 'all', treatment: 'both', desc: 'Final consolidated bill with breakup of lab, medicines, room rent, services, etc.', kws: ['final bill', 'final medical bill', 'consolidated bill', 'bill breakup', 'final bill breakup'] },
                    { key: 'bill_breakup', title: 'Bill Breakup', mandatory: 'all', treatment: 'both', desc: 'Detailed breakup of the final bill showing charges category-wise.', kws: ['bill breakup', 'breakup', 'final bill breakup'] },
                    { key: 'cash_receipts', title: 'Pre-numbered cash receipts', mandatory: 'all', treatment: 'both', desc: 'Original pre-numbered cash receipts supporting the hospital main bill.', kws: ['cash receipt', 'pre numbered receipt'] },
                    { key: 'advance_receipts', title: 'Advance paid receipts', mandatory: 'all', treatment: 'both', desc: 'All advance paid receipts, if any.', kws: ['advance receipt'] },
                    { key: 'discharge_summary', title: 'Detailed Discharge Summary', mandatory: 'all', treatment: 'both', desc: 'Discharge summary with admission/discharge date/time, symptoms, diagnosis, hospital course, treatment done, and advice; duly certified.', kws: ['discharge summary'] },
                    { key: 'diagnostic_reports', title: 'All investigation/lab/radiology reports', mandatory: 'all', treatment: 'both', desc: 'Certified diagnostic reports (lab, radiology, histopath, biopsy, culture) with doctor’s advice/prescriptions.', kws: ['investigation report', 'investigation', 'investigations', 'investigation/diagnostics', 'diagnostics', 'lab report', 'diagnostic', 'radiology', 'histopath', 'biopsy', 'culture'] },
                    { key: 'pharmacy_bills', title: 'Pharmacy/Medicine bills with prescriptions', mandatory: 'all', treatment: 'both', desc: 'Pharmacy bills (date-wise) with relevant prescriptions/indent slips; investigation cash memos/bills.', kws: ['pharmacy bill', 'pharmacy bills', 'medicine bill', 'indent', 'pharmacy'] },
                    { key: 'lab_bills', title: 'Lab bills with corresponding reports', mandatory: 'all', treatment: 'both', desc: 'Original lab bills with relevant diagnostic test reports for each lab bill claimed.', kws: ['lab bill', 'laboratory bill'] },
                    { key: 'prescription_slips', title: 'Prescription / Requisition slips', mandatory: 'all', treatment: 'both', desc: 'Requisition slips/consultation papers for any consultation fees claimed.', kws: ['prescription', 'requisition', 'doctor note'] },
                    { key: 'consultation_papers', title: 'First consultation notes & admission advice', mandatory: 'all', treatment: 'both', desc: 'First consultation notes (planned/emergency) with admission advice from treating doctor.', kws: ['consultation', 'admission advice', 'first consultation'] },
                    { key: 'icp_papers', title: 'ICP Papers', mandatory: 'all', treatment: 'both', desc: 'Complete indoor case papers: admission notes, progress notes, vitals, drug chart, I/O chart, nursing notes, transfusion details.', kws: ['icp', 'indoor case paper', 'indoor case papers', 'case paper', 'progress notes', 'drug chart', 'i/o chart', 'nursing notes'] },
                    { key: 'ot_notes', title: 'OT Notes', mandatory: 'all', treatment: 'surgical', desc: 'Certified operation theatre notes with procedure details and timings.', kws: ['ot notes', 'operation theatre', 'operative notes'] },
                    { key: 'anaesthesia_notes', title: 'Anaesthesia Notes', mandatory: 'all', treatment: 'surgical', desc: 'Pre/intra/post anaesthesia notes.', kws: ['anaesthesia notes', 'anesthesia notes', 'pre anaesthesia', 'pre-anaesthesia', 'anaesthesia'] },
                    { key: 'nursing_notes', title: 'Nursing Notes', mandatory: 'all', treatment: 'both', desc: 'Date/time-stamped nursing observation/progress notes.', kws: ['nursing notes', 'nursing observation', 'nursing'] },
                    { key: 'implant_bill', title: 'Implant Bill', mandatory: 'all', treatment: 'surgical', desc: 'Implant invoice and stickers; vendor invoice if self-purchased.', kws: ['implant bill', 'implant invoice', 'stent', 'iol', 'sticker'] },
                  ]
                },
                {
                  id: 'condition_specific',
                  title: 'Condition-specific documents (as applicable)',
                  collapsed: true,
                  items: [
                    { key: 'physiotherapy_chart', title: 'Physiotherapy chart', mandatory: 'conditional', treatment: 'both', desc: 'Physiotherapy charts where physiotherapy treatment was given.', kws: ['physio', 'physiotherapy'] },
                    { key: 'radiology_films', title: 'Radiology films with reports', mandatory: 'conditional', treatment: 'both', desc: 'X-Ray/CT/MRI films with reports where billed and supporting diagnosis (fracture, head injury, CVA, stones, etc.).', kws: ['x ray', 'x-ray', 'ct', 'mri', 'film'] },
                    { key: 'mlc_fir', title: 'MLC/FIR (accidents/burns/poisoning etc.)', mandatory: 'conditional', treatment: 'both', desc: 'Medico-legal/FIR copy for accident/burns/suicidal/poisoning/other injury cases; or hospital letter if not done.', kws: ['mlc', 'fir', 'police'] },
                    { key: 'alcohol_certificate', title: 'Alcohol influence certificate', mandatory: 'conditional', treatment: 'both', desc: 'Treating doctor certificate on alcohol influence at time of accident (all RTA claims).', kws: ['alcohol certificate', 'intoxication'] },
                    { key: 'ectopic_certificate', title: 'Ectopic pregnancy certificate', mandatory: 'conditional', treatment: 'both', desc: 'Gynaecologist letter stating life-threatening condition requiring immediate intervention; with ultrasound.', kws: ['ectopic', 'gynaec'] },
                    { key: 'usg_reports', title: 'Ultrasound scan (USG) reports', mandatory: 'conditional', treatment: 'both', desc: 'USG reports for abortion, fibroid uterus, missed abortion; include GPLA status.', kws: ['usg', 'ultrasound', 'scan'] },
                    { key: 'gpla_status', title: 'GPLA status', mandatory: 'conditional', treatment: 'both', desc: 'For maternity claims: GPLA status, antenatal records, and ultrasound reports.', kws: ['gpla', 'antenatal'] },
                    { key: 'indoor_case_papers', title: 'Complete indoor case papers', mandatory: 'medical', treatment: 'medical', desc: 'Certified copies of ICP: admission notes, progress notes, vitals, TPR, drug chart, I/O chart, nursing notes, blood transfusion details and bag details where applicable.', kws: ['indoor case', 'case paper', 'progress notes', 'vital', 'tpr', 'drug chart', 'nursing notes'] },
                    { key: 'prolonged_stay_letter', title: 'Prolonged hospitalization justification', mandatory: 'conditional', treatment: 'both', desc: 'Letter from treating doctor justifying stay beyond 4 days.', kws: ['prolonged stay', 'long stay', 'justification'] },
                    { key: 'higher_antibiotics', title: 'Higher/multiple antibiotics justification', mandatory: 'conditional', treatment: 'both', desc: 'Blood/urine culture reports and justification letter explaining preference of higher antibiotics.', kws: ['antibiotic', 'culture'] },
                    { key: 'surgical_supporting', title: 'Surgical diagnosis supporting reports', mandatory: 'surgical', treatment: 'surgical', desc: 'Pre/post-op supporting reports (e.g., USG/CT/MRI for appendectomy, hernia, cholecystectomy; ECG/ECHO/ANGIO etc. for cardiac; X-ray/CT/MRI for joints/head; dental OPG, cataract A-scan).', kws: ['pre op', 'post op', 'appendectomy', 'hernia', 'chole', 'hysterectomy', 'angiogram', 'angioplasty', 'echo', 'tmt', 'opg', 'a scan', 'a-scan'] },
                    { key: 'neonatal_bilirubin', title: 'Neonatal jaundice bilirubin reports', mandatory: 'medical', treatment: 'medical', desc: 'Serum bilirubin reports after 24h and serial monitoring after 48h of birth.', kws: ['bilirubin', 'neonatal'] },
                    { key: 'chest_complaints', title: 'Chest/heart-related supporting reports', mandatory: 'conditional', treatment: 'both', desc: 'Chest X-ray for lung complaints; ECG/2D echo for heart-related; CT chest if done.', kws: ['chest x', 'ecg', '2d echo', 'ct chest'] },
                    { key: 'implant_invoice', title: 'Implant invoice and stickers', mandatory: 'conditional', treatment: 'surgical', desc: 'Implant invoice with stickers; for self-purchase, include vendor invoice and payment receipt; stent/IOL stickers as applicable.', kws: ['implant invoice', 'stent', 'iol', 'sticker'] },
                    { key: 'blood_bank', title: 'Blood bank receipts/stickers', mandatory: 'conditional', treatment: 'both', desc: 'Receipts and stickers when blood transfusion done.', kws: ['blood bank', 'transfusion'] },
                    { key: 'ambulance_details', title: 'Ambulance usage details', mandatory: 'conditional', treatment: 'both', desc: 'From–to details with dates for ambulance charges (e.g., home to hospital; hospital to home).', kws: ['ambulance'] },
                    { key: 'ot_notes', title: 'OT notes', mandatory: 'surgical', treatment: 'surgical', desc: 'Certified OT notes: procedure planned, date, start/end times, anaesthesia mode, surgeon/assistant/anaesthetist names, details.', kws: ['ot notes', 'operation theatre', 'operative notes'] },
                    { key: 'pac_notes', title: 'Pre-anaesthesia (PAC) notes', mandatory: 'surgical', treatment: 'surgical', desc: 'Certified pre-anaesthesia consultation/consent notes where applicable.', kws: ['pac', 'anaesthesia', 'pre anaesthesia', 'pre-anaesthesia'] },
                    { key: 'dialysis_flow', title: 'Dialysis flow chart', mandatory: 'medical', treatment: 'medical', desc: 'Certified date-wise dialysis flow charts in dialysis cases.', kws: ['dialysis flow'] },
                    { key: 'radiotherapy_flow', title: 'Radiotherapy flow chart', mandatory: 'medical', treatment: 'medical', desc: 'Date-wise radiotherapy flow chart with number of fractions per sitting.', kws: ['radiotherapy', 'rt flow'] },
                    { key: 'advanced_proc_justification', title: 'Advanced procedure justification', mandatory: 'conditional', treatment: 'both', desc: 'Treating doctor certificate on why advanced procedure preferred vs conventional and why condition not treatable conventionally.', kws: ['advanced procedure', 'justification'] },
                  ]
                }
              ];

              const handleUpload = async (file, item) => {
                if (!file) return;
                setScrutinyUploading((p) => ({ ...p, [item.key]: true }));
                try {
                  const uploaded = await uploadDischargeDocument(
                    application.applicationId,
                    file,
                    item.title,
                    { description: `Uploaded via Scrutiny • ${item.title}` }
                  );
                  if (!uploaded?.success) throw new Error(uploaded?.error || 'Upload failed');
                  if (uploaded.document) {
                    // If user declined earlier, after upload, auto-attach to Documents tab
                    try {
                      await attachDischargeDocToDocuments(application.applicationId, uploaded.document.id, item.title);
                    } catch (_) { }
                    // Reload application data from server to ensure consistency and avoid duplicates
                    await loadApplicationData();
                  }
                } catch (e) {
                  alert(e.message || 'Upload failed');
                } finally {
                  setScrutinyUploading((p) => ({ ...p, [item.key]: false }));
                }
              };

              const handleAcceptExisting = async (existingDoc, item) => {
                if (!existingDoc) return;
                setScrutinyActionLoading((p) => ({ ...p, [item.key]: true }));
                try {
                  const res = await attachDischargeDocToDocuments(application.applicationId, existingDoc.id, item.title);
                  if (!res?.success) throw new Error(res?.error || 'Failed to attach');
                  setScrutinyDecision((p) => ({ ...p, [item.key]: 'accepted' }));
                  await loadApplicationData();
                } catch (e) {
                  alert(e.message || 'Failed to accept');
                } finally {
                  setScrutinyActionLoading((p) => ({ ...p, [item.key]: false }));
                }
              };

              const markDecline = (item) => {
                setScrutinyDecision((p) => ({ ...p, [item.key]: 'decline' }));
              };

              // Compute completion for required items (mandatory === 'all')
              let totalRequired = 0;
              let completedRequired = 0;

              const renderItem = (item) => {
                const matches = allDocs
                  .filter((d) => matchesAny(d, item.kws || []))
                  .sort((a, b) => (toJsDate(b.uploadedAt) - toJsDate(a.uploadedAt)));
                const existing = matches[0];

                // For display: remove duplicates already shown earlier
                const filteredForDisplay = matches.filter((m) => !seenDocKeys.has(docIdentity(m)));
                // If we will display any new file here, remember them as seen
                filteredForDisplay.forEach((m) => seenDocKeys.add(docIdentity(m)));
                const uploading = !!scrutinyUploading[item.key];
                const isSubmitted = application?.workflow?.dischargeSettlement?.scrutinySubmission?.status === 'submitted';
                const treatmentBadge = item.treatment === 'surgical' ? 'bg-red-100 text-red-800 border-red-200' : item.treatment === 'medical' ? 'bg-indigo-100 text-indigo-800 border-indigo-200' : 'bg-teal-100 text-teal-800 border-teal-200';
                const mandatoryBadge = item.mandatory === 'all' ? { label: 'Required', cls: 'bg-blue-100 text-blue-800 border-blue-200' } : { label: 'As applicable', cls: 'bg-amber-100 text-amber-800 border-amber-200' };
                if (item.mandatory === 'all') {
                  totalRequired += 1;
                  if (existing) completedRequired += 1;
                }
                return (
                  <div key={item.key} className="p-3 border border-gray-200 rounded-md bg-gray-50">
                    <div className="flex items-start justify-between gap-3">
                      <div className="flex-1">
                        <div className="flex items-center gap-2 flex-wrap">
                          <p className="font-medium text-gray-900">{item.title}</p>
                          <span className={`text-xs px-2 py-0.5 rounded-full border ${treatmentBadge}`}>{item.treatment === 'both' ? 'Both' : (item.treatment === 'surgical' ? 'Surgical' : 'Medical')}</span>
                          <span className={`text-xs px-2 py-0.5 rounded-full border ${mandatoryBadge.cls}`}>{mandatoryBadge.label}</span>
                          <details>
                            <summary className="text-xs text-gray-600 cursor-pointer inline-flex items-center gap-1"><Info className="h-3 w-3" /> Info</summary>
                            <div className="mt-2 text-xs text-gray-700 bg-white border border-gray-200 rounded p-2 max-w-prose">{item.desc}</div>
                          </details>
                        </div>
                        {existing ? (
                          <div className="mt-2 text-sm text-gray-700">
                            {filteredForDisplay.length > 0 ? (
                              <>
                                <p className="inline-flex items-center gap-2">
                                  <span className="font-medium">Existing:</span>
                                  <button onClick={() => openDocument(filteredForDisplay[0])} className="text-blue-600 hover:text-blue-800" title="View document">{filteredForDisplay[0].title || filteredForDisplay[0].fileName}</button>
                                  <span className={`text-xs px-2 py-0.5 rounded-full ${filteredForDisplay[0].dispatchStatus === 'approved' ? 'bg-green-100 text-green-800' : filteredForDisplay[0].dispatchStatus === 'rejected' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800'}`}>
                                    {filteredForDisplay[0].dispatchStatus ? `${filteredForDisplay[0].dispatchStatus.charAt(0).toUpperCase()}${filteredForDisplay[0].dispatchStatus.slice(1)} for Dispatch` : 'Uploaded'}
                                  </span>
                                </p>
                                {filteredForDisplay.length > 1 && (
                                  <details className="mt-1">
                                    <summary className="text-xs text-gray-600 cursor-pointer">{filteredForDisplay.length - 1} more file{filteredForDisplay.length > 2 ? 's' : ''}</summary>
                                    <ul className="mt-1 space-y-1">
                                      {filteredForDisplay.slice(1).map((m) => (
                                        <li key={m.id || m.url} className="flex items-center gap-2 text-xs">
                                          <button onClick={() => openDocument(m)} className="text-blue-600 hover:text-blue-800" title="View document">{m.title || m.fileName}</button>
                                          <span className="text-gray-400">•</span>
                                          <span className="text-gray-500">{formatDate(m.uploadedAt)}</span>
                                        </li>
                                      ))}
                                    </ul>
                                  </details>
                                )}
                              </>
                            ) : (
                              <p className="text-xs text-gray-600">Shared from another item above.</p>
                            )}
                          </div>
                        ) : (
                          <p className="mt-2 text-sm text-yellow-800">No document uploaded yet.</p>
                        )}
                      </div>
                      <div className="w-72 text-right">
                        {!isSubmitted && (
                          <div className="inline-flex items-center gap-2 mb-2">
                            {existing && scrutinyDecision[item.key] !== 'decline' ? (
                              scrutinyDecision[item.key] === 'accepted' ? (
                                <>
                                  <span className="text-xs px-2 py-0.5 rounded-full bg-green-50 text-green-700 border border-green-200">Accepted</span>
                                  <button
                                    onClick={() => markDecline(item)}
                                    className="text-[11px] text-blue-700 hover:text-blue-900 underline"
                                    title="Edit / Replace"
                                  >
                                    Edit
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    onClick={() => handleAcceptExisting(existing, item)}
                                    disabled={scrutinyActionLoading[item.key]}
                                    className="text-xs bg-green-600 text-white px-2 py-1 rounded hover:bg-green-700 disabled:opacity-50"
                                    title="Accept and move to Documents"
                                  >
                                    {scrutinyActionLoading[item.key] ? 'Saving…' : 'Accept'}
                                  </button>
                                  <button
                                    onClick={() => markDecline(item)}
                                    disabled={scrutinyActionLoading[item.key]}
                                    className="text-xs bg-red-600 text-white px-2 py-1 rounded hover:bg-red-700 disabled:opacity-50"
                                    title="Decline and upload a new document"
                                  >
                                    Decline
                                  </button>
                                </>
                              )
                            ) : null}
                          </div>
                        )}

                        {/* File input only when no existing OR declined, and not submitted */}
                        {(!isSubmitted && (!existing || scrutinyDecision[item.key] === 'decline')) && (
                          <div>
                            <label className="block text-xs font-medium text-gray-700 mb-1">{existing ? 'Replace Document' : 'Upload Document'}</label>
                            <input
                              type="file"
                              accept="application/pdf,image/jpeg,image/png"
                              onChange={(e) => handleUpload(e.target.files?.[0], item)}
                              disabled={uploading}
                              className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm bg-white"
                            />
                            {uploading && <p className="text-xs text-gray-500 mt-1">Uploading…</p>}
                          </div>
                        )}

                        {/* Helper when hidden */}
                        {!isSubmitted && existing && scrutinyDecision[item.key] !== 'decline' && (
                          <p className="text-[11px] text-gray-500">Choose file appears when you Decline or Edit.</p>
                        )}

                        {isSubmitted && (
                          <p className="text-[11px] text-gray-500">Sent to doctor — actions disabled.</p>
                        )}
                      </div>
                    </div>
                  </div>
                );
              };

              return (
                <div className="space-y-4">
                  {/* Summary */}
                  <div className="mb-2 text-sm text-gray-700 flex items-center gap-3">
                    <span>Required completed: <span className="font-semibold">{completedRequired}</span>/<span className="font-semibold">{totalRequired}</span></span>
                    <span className="text-xs text-gray-500">Condition-specific items are as applicable</span>
                  </div>

                  {/* Groups */}
                  {GROUPS.map((group) => (
                    <div key={group.id} className="border border-gray-200 rounded-md">
                      <div className="px-3 py-2 border-b bg-gray-50 flex items-center justify-between">
                        <h4 className="text-sm font-semibold text-gray-800">{group.title}</h4>
                        {/* Simple counter */}
                        <span className="text-xs text-gray-600">{group.items.filter(it => it.mandatory === 'all' && allDocs.some(d => matchesAny(d, it.kws))).length}/{group.items.filter(it => it.mandatory === 'all').length} required</span>
                      </div>
                      {/* Collapsible for condition-specific */}
                      {group.id === 'condition_specific' ? (
                        <details className="p-3">
                          <summary className="text-sm text-gray-700 cursor-pointer">Show condition-specific items</summary>
                          <div className="mt-3 space-y-3">
                            {group.items.map(renderItem)}
                          </div>
                        </details>
                      ) : (
                        <div className="p-3 space-y-3">
                          {group.items.map(renderItem)}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              );
            })()}
          </div>
        )}

        {/* Dispatch gating notice removed per simplified flow */}

        {/* Dispatch Documents Upload (separate, not for doctor approval) */}
        {isFALAcceptedByHospital ? (
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Upload Dispatch Documents</h3>
            </div>
            <p className="text-sm text-gray-600 mb-3">Upload final packet documents (e.g., Claim Form, KYC, ID proofs) and also upload the Approved Scrutiny Bundle you downloaded above. These are separate from discharge and not sent for doctor approval.</p>
            <datalist id="dispatch-upload-type-suggestions">
              {['Discharge Summary', 'Final Medical Bill', 'Procedure Bill', 'Pharmacy Bill', 'Investigation Reports', 'Implant Invoice', 'Doctor\'s Prescription', 'ID Proof Copy', 'Insurance Claim Form', 'KYC Set', 'Cancelled Cheque', 'Authorization Letter'].map((s) => (<option key={s} value={s} />))}
            </datalist>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium text-gray-700">Choose File</label>
                <input
                  type="file"
                  accept={accept}
                  onChange={(e) => setDispatchUpload((p) => ({ ...p, file: e.target.files && e.target.files[0] }))}
                  className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 bg-white"
                />
                {dispatchUpload?.file && (
                  <p className="text-xs text-gray-500 mt-1">{dispatchUpload.file.name} • {(dispatchUpload.file.size / 1024).toFixed(1)} KB</p>
                )}
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700">Type</label>
                <input
                  list="dispatch-upload-type-suggestions"
                  value={dispatchUpload.type}
                  onChange={(e) => setDispatchUpload((p) => ({ ...p, type: e.target.value }))}
                  placeholder="Select type"
                  className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700">Title</label>
                <input
                  value={dispatchUpload.title}
                  onChange={(e) => setDispatchUpload((p) => ({ ...p, title: e.target.value }))}
                  placeholder="e.g., Insurance Claim Form"
                  className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700">Description (optional)</label>
                <input
                  value={dispatchUpload.description}
                  onChange={(e) => setDispatchUpload((p) => ({ ...p, description: e.target.value }))}
                  placeholder="Add notes (optional)"
                  className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                />
              </div>
              <div className="md:col-span-2 flex justify-between items-center">
                <div className="text-sm text-gray-600">Already uploaded for dispatch packet: <span className="font-medium">{dispatchDocs.length}</span></div>
                <div>
                  <button
                    onClick={onDispatchDocsUpload}
                    disabled={!dispatchUpload?.file || !dispatchUpload?.title || !dispatchUpload?.type || uploadingDispatchDocs}
                    className="bg-teal-600 text-white px-4 py-2 rounded-md hover:bg-teal-700 disabled:opacity-50"
                  >
                    {uploadingDispatchDocs ? 'Uploading…' : 'Upload'}
                  </button>
                </div>
              </div>
              {dispatchUploadError && (
                <p className="text-sm text-red-600">{dispatchUploadError}</p>
              )}
            </div>
            {dispatchDocs.length > 0 && (
              <div className="mt-6">
                <h4 className="text-sm font-semibold text-gray-800 mb-2">Uploaded Dispatch Documents ({dispatchDocs.length})</h4>
                <div className="space-y-2">
                  {dispatchDocs.map((doc) => (
                    <div key={doc.id || doc.url} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                      <div>
                        <p className="font-medium text-gray-900">{doc.title || doc.fileName}</p>
                        {doc.type && <p className="text-xs text-gray-600">Type: {doc.type}</p>}
                        {doc.description && <p className="text-xs text-gray-600">Note: {doc.description}</p>}
                        <p className="text-xs text-gray-600">Uploaded {formatDate(doc.uploadedAt)} by {doc.uploaderName || doc.uploadedBy || 'Hospital'} • {(doc.size ? (doc.size / 1024).toFixed(1) : '?')} KB</p>
                      </div>
                      <div className="flex items-center space-x-2">
                        <button onClick={() => openDocument(doc)} className="text-blue-600 hover:text-blue-800" title="View"><Eye className="h-4 w-4" /></button>
                        <button onClick={() => downloadFile(doc.url, doc.fileName || 'document')} className="text-green-600 hover:text-green-800" title="Download"><Download className="h-4 w-4" /></button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="bg-white rounded-lg border border-yellow-200 p-4">
            <p className="text-sm text-yellow-800">Final Approval Letter not yet accepted – dispatch packet uploads (final packet docs) will appear after FAL acceptance. You can continue uploading discharge documents above.</p>
          </div>
        )}

        {/* Dispatch Documents - show only after FAL acceptance + doctor clearance + approved docs */}
        {isFALAcceptedByHospital && canShowDispatch && (
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Dispatch Documents</h3>
              <button onClick={downloadApprovedBundle} disabled={!hasAnyApprovedDoc || bundleDownloading} className="text-sm text-teal-700 hover:text-teal-900 disabled:opacity-50 flex items-center gap-2" title={!hasAnyApprovedDoc ? 'No approved documents yet' : ''}>
                {bundleDownloading ? (
                  <>
                    <Loader className="h-3 w-3 animate-spin" /> Preparing…
                  </>
                ) : (
                  `Download Approved Scrutiny Bundle${approvedCount ? ` (${approvedCount} items)` : ''}`
                )}
              </button>
            </div>
            {/* Dispatch Address (visible only after doctor clearance) */}
            <div className="mb-3">
              <h4 className="text-sm font-semibold text-gray-800 mb-1">Dispatch Address</h4>
              <div className="text-sm p-3 bg-gray-50 rounded border">
                <p className="font-medium text-gray-900">{pvDispatchAddr?.recipientName || 'N/A'}</p>
                {pvDispatchAddr?.contactNumber && <p className="text-gray-700">{pvDispatchAddr.contactNumber}</p>}
                <p className="text-gray-700">{pvDispatchAddr?.addressLine1 || 'N/A'}</p>
                {pvDispatchAddr?.addressLine2 && <p className="text-gray-700">{pvDispatchAddr.addressLine2}</p>}
                <p className="text-gray-700">{pvDispatchAddr?.city || 'N/A'}, {pvDispatchAddr?.state || 'N/A'} - {pvDispatchAddr?.pincode || 'N/A'}</p>
              </div>
            </div>
            <div className="bg-teal-50 border border-teal-200 rounded-md p-3 mb-4">
              <p className="text-sm text-teal-800">Dispatch will include the Approved Scrutiny Bundle generated from doctor-approved documents.</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Mode of Dispatch</label>
                <select value={dispatchForm.mode} onChange={(e) => setDispatchForm((p) => ({ ...p, mode: e.target.value }))} className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm">
                  <option>Courier</option>
                  <option>Speed Post</option>
                  <option>Email</option>
                  <option>Other</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Dispatch Date & Time</label>
                <input type="datetime-local" value={dispatchForm.dispatchedAt} onChange={(e) => setDispatchForm((p) => ({ ...p, dispatchedAt: e.target.value }))} className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tracking ID</label>
                <input type="text" value={dispatchForm.trackingId} onChange={(e) => setDispatchForm((p) => ({ ...p, trackingId: e.target.value }))} placeholder="Optional" className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Notes</label>
                <input type="text" value={dispatchForm.notes} onChange={(e) => setDispatchForm((p) => ({ ...p, notes: e.target.value }))} placeholder="Optional" className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm" />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">POD Slip (PDF/JPG/PNG)</label>
                <input
                  type="file"
                  accept="application/pdf,image/jpeg,image/png"
                  onChange={(e) => setDispatchForm((p) => ({ ...p, podFile: e.target.files && e.target.files[0] }))}
                  className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm bg-white"
                />
                <p className="text-xs text-gray-500 mt-1">Optional. Upload proof of delivery; Finance will be able to view it.</p>
              </div>
            </div>
            <div className="flex justify-end mt-4">
              <button onClick={handleDispatchSubmit} disabled={dispatching} className="px-4 py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700 disabled:opacity-50">
                {dispatching ? 'Dispatching...' : 'Submit Dispatch'}
              </button>
            </div>
          </div>
        )}

        {/* Dispatch History */}
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Dispatch History ({dispatches.length})</h3>
          {dispatches.length === 0 ? (
            <p className="text-sm text-gray-600">No dispatches yet.</p>
          ) : (
            <div className="space-y-3">
              {dispatches.map((d) => (
                <div key={d.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                  <div>
                    <p className="font-medium text-gray-900">{d.mode} • {d.trackingId || 'No Tracking'}</p>
                    <p className="text-xs text-gray-600">Dispatched: {formatDate(d.dispatchedAt)} • {d.documents?.length || 0} document(s)</p>
                    {d.notes && <p className="text-xs text-gray-600">Notes: {d.notes}</p>}
                    {d.pod?.url && (
                      <p className="text-xs text-gray-600">POD: <a href={d.pod.url} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">{d.pod.name || 'View POD'}</a></p>
                    )}
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${d.status === 'received' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>
                      {d.status === 'received' ? 'Received' : 'Dispatched'}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderSanctions = () => {
    const availableLetters = [
      {
        id: 'kyp',
        title: 'KYP Letter',
        description: 'Know Your Patient verification letter',
        icon: User,
        color: 'blue'
      },
      {
        id: 'approval',
        title: 'Final Approval Letter',
        description: 'Application approval confirmation',
        icon: CheckCircle,
        color: 'green'
      },
      {
        id: 'disbursal',
        title: 'Disbursal Letter',
        description: 'Treatment cost disbursal authorization',
        icon: CreditCard,
        color: 'purple'
      },
      {
        id: 'closure',
        title: 'Case Closure Letter',
        description: 'Final case closure and settlement',
        icon: Award,
        color: 'orange'
      }
    ];

    // Check if hospital can initiate discharge process
    const canInitiateDischarge = application.workflow?.medicalVerification?.kypGenerated &&
      application.status !== 'discharge_process' &&
      application.status !== 'closed' &&
      !application.dischargeInitiated;

    return (
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-xl font-semibold text-gray-900">Documents & Letters</h2>
            <p className="text-sm text-gray-600">Download official letters and documents</p>
          </div>

          {/* Discharge Process Button for Hospitals */}
          {canInitiateDischarge && (
            <button
              onClick={() => setShowDischargeModal(true)}
              className="bg-orange-600 text-white px-4 py-2 rounded-lg hover:bg-orange-700 transition-colors flex items-center space-x-2"
            >
              <Activity className="h-4 w-4" />
              <span>Initiate Discharge Process</span>
            </button>
          )}
        </div>

        {/* Available Letters for Download Only */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {availableLetters.map((letter) => {
            const Icon = letter.icon;

            // Handle KYP letter specially since it's stored in workflow
            let existingLetter;
            if (letter.id === 'kyp' && application.workflow?.medicalVerification?.kypGenerated &&
              getKYPDoctorApproval()?.status === 'approved') {
              existingLetter = {
                id: 'kyp',
                type: 'kyp',
                title: 'KYP Letter',
                url: null, // KYP uses dynamic PDF generation
                fileName: 'KYP-Letter.pdf',
                generatedAt: application.workflow.medicalVerification.kypGeneratedAt || application.workflow.medicalVerification.verifiedAt || new Date(),
                generatedBy: 'Medical Team',
                isKYPLetter: true, // Flag to identify KYP letters for special handling
                kypData: application.workflow.medicalVerification.kypData
              };
            } else {
              existingLetter = sanctions.find(s => s.type === letter.id);
            }

            // Fallback for approval letter if workflow has quick link
            if (!existingLetter && letter.id === 'approval' && application.workflow?.dischargeSettlement?.finalApprovalLetterUrl) {
              existingLetter = {
                id: 'approval-quicklink',
                type: 'approval',
                title: 'Final Approval Letter',
                url: application.workflow.dischargeSettlement.finalApprovalLetterUrl,
                fileName: 'Final-Approval-Letter.pdf',
                generatedAt: application.workflow?.dischargeSettlement?.processedAt || application.updatedAt || new Date(),
                generatedBy: 'Financial Team'
              };
            }

            const isAvailable = Boolean(existingLetter);

            const kypAck = letter.id === 'kyp' ? getKYPAck() : null;
            const sanctionAck = existingLetter && !existingLetter.isKYPLetter ? getSanctionAck(existingLetter) : null;
            const disabledDownload = (letter.id === 'kyp' ? kypAck?.status !== 'accepted' : (sanctionAck ? sanctionAck.status !== 'accepted' : false));

            // To-and-fro loop rules
            const kypGenAt = toJsDate(application?.workflow?.medicalVerification?.kypGeneratedAt);
            const kypAckAt = toJsDate(kypAck?.at);
            const kypAcceptLocked = letter.id === 'kyp' && kypAck?.status === 'challenged' && (!kypGenAt || (kypAckAt && kypGenAt <= kypAckAt));
            // Freeze KYP actions when challenged until doctor posts a response
            const kypAwaitingDoctor = letter.id === 'kyp' && kypAck?.status === 'challenged' && !kypAck?.doctorResponse;
            const kypHideActions = letter.id === 'kyp' && kypAck?.status === 'accepted';

            const isSanctionQuicklink = existingLetter?.id?.startsWith('approval-quicklink');
            const sanctionHideActions = !!sanctionAck && sanctionAck.status === 'accepted';
            const sanctionAcceptLocked = !!sanctionAck && sanctionAck.status === 'challenged';

            return (
              <div key={letter.id} className="bg-white border border-gray-200 rounded-lg p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className={`p-2 rounded-lg ${isAvailable ? `bg-${letter.color}-100` : 'bg-gray-100'
                      }`}>
                      <Icon className={`h-5 w-5 ${isAvailable ? `text-${letter.color}-600` : 'text-gray-400'
                        }`} />
                    </div>
                    <div>
                      <h3 className={`font-medium ${isAvailable ? 'text-gray-900' : 'text-gray-500'}`}>
                        {letter.title}
                      </h3>
                      <p className={`text-sm ${isAvailable ? 'text-gray-600' : 'text-gray-400'}`}>
                        {letter.description}
                      </p>
                      {letter.id === 'kyp' && getKYPDoctorApproval()?.status === 'rejected' && (
                        <p className="text-xs text-red-600 mt-1">Doctor rejected KYP: {getKYPDoctorApproval()?.reason || 'No reason provided'}</p>
                      )}
                    </div>
                  </div>

                  <span className={`px-2 py-1 text-xs font-semibold rounded-full ${isAvailable
                      ? 'bg-green-100 text-green-800'
                      : 'bg-gray-100 text-gray-600'
                    }`}>
                    {isAvailable ? 'Available' : 'Pending'}
                  </span>
                </div>

                {existingLetter ? (
                  <div className="space-y-3">
                    <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-sm font-medium text-green-800">Letter Available</p>
                          <p className="text-xs text-green-600">
                            Generated on {formatDate(existingLetter.generatedAt)}
                          </p>
                          {(letter.id === 'kyp') && (() => {
                            const kypApproval = getKYPDoctorApproval();
                            const genAt = toJsDate(application?.workflow?.medicalVerification?.kypGeneratedAt);
                            const ackAt = toJsDate(kypAck?.at);
                            const isRevisedAfterChallenge = (kypAck?.status === 'challenged') && genAt && ackAt && genAt > ackAt;
                            const showPendingRevised = (kypApproval?.status === 'approved' && (kypAck?.status !== 'accepted')) || isRevisedAfterChallenge;

                            const label = kypAck?.status === 'accepted'
                              ? 'ACCEPTED'
                              : showPendingRevised
                                ? 'PENDING — revised KYP ready'
                                : (kypAck?.status || 'pending').toUpperCase();

                            const cls = kypAck?.status === 'accepted'
                              ? 'text-green-700'
                              : showPendingRevised
                                ? 'text-teal-700'
                                : (kypAck?.status === 'challenged' ? 'text-orange-700' : 'text-gray-700');

                            return (
                              <p className="text-xs mt-1">
                                Acknowledgement: <span className={cls}>{label}</span>
                                {(!showPendingRevised && kypAck?.comment) ? ` • ${kypAck.comment}` : ''}
                              </p>
                            );
                          })()}
                          {(letter.id !== 'kyp') && sanctionAck && (
                            <p className="text-xs mt-1">Acknowledgement: <span className={`${sanctionAck.status === 'accepted' ? 'text-green-700' : sanctionAck.status === 'challenged' ? 'text-orange-700' : 'text-gray-700'}`}>{(sanctionAck.status || 'pending').toUpperCase()}</span>{sanctionAck.comment ? ` • ${sanctionAck.comment}` : ''}</p>
                          )}
                        </div>
                        <div className="flex items-center space-x-2">
                          <button
                            onClick={() => openLetter(existingLetter)}
                            className="text-blue-600 hover:text-blue-800 text-sm"
                          >
                            <Eye className="h-4 w-4" />
                          </button>
                          <button
                            onClick={() => handleLetterDownload(existingLetter)}
                            disabled={disabledDownload}
                            className={`px-3 py-1 rounded text-sm flex items-center space-x-1 ${disabledDownload ? 'bg-gray-300 text-gray-600 cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700'}`}
                          >
                            <Download className="h-3 w-3" />
                            <span>Download</span>
                          </button>
                        </div>
                      </div>
                      <div className="mt-3 flex items-center space-x-2">
                        {letter.id === 'kyp' ? (
                          !kypHideActions && (
                            <>
                              <button
                                onClick={() => handleKYPAcknowledgement('accepted')}
                                disabled={ackActionLoading.kyp || kypAcceptLocked || kypAwaitingDoctor}
                                className="text-xs bg-green-600 text-white px-2 py-1 rounded hover:bg-green-700 disabled:opacity-50"
                              >
                                Accept
                              </button>
                              <button
                                onClick={() => openChallengeModal('kyp')}
                                disabled={ackActionLoading.kyp || kypAwaitingDoctor}
                                className="text-xs bg-orange-600 text-white px-2 py-1 rounded hover:bg-orange-700 disabled:opacity-50"
                              >
                                Challenge
                              </button>
                              {kypAwaitingDoctor ? (
                                <span className="text-xs text-gray-500 ml-1">Awaiting doctor response</span>
                              ) : kypAcceptLocked ? (
                                <span className="text-xs text-gray-500 ml-1">Waiting for revised KYP</span>
                              ) : null}
                            </>
                          )
                        ) : (
                          !sanctionHideActions && !isSanctionQuicklink && (
                            <>
                              <button
                                onClick={() => handleSanctionAcknowledgement(existingLetter, 'accepted')}
                                disabled={ackActionLoading[existingLetter.id] || sanctionAcceptLocked}
                                className="text-xs bg-green-600 text-white px-2 py-1 rounded hover:bg-green-700 disabled:opacity-50"
                              >
                                Accept
                              </button>
                              <button
                                onClick={() => openChallengeModal('sanction', existingLetter)}
                                disabled={ackActionLoading[existingLetter.id]}
                                className="text-xs bg-orange-600 text-white px-2 py-1 rounded hover:bg-orange-700 disabled:opacity-50"
                              >
                                Challenge
                              </button>
                              {sanctionAcceptLocked && (
                                <span className="text-xs text-gray-500 ml-1">Waiting for revised letter</span>
                              )}
                            </>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-4">
                    <p className="text-sm text-gray-500">
                      {letter.id === 'kyp' ? (
                        application.workflow?.medicalVerification?.kypGenerated ? (
                          getKYPDoctorApproval()?.status === 'rejected' ?
                            'KYP letter was rejected by the doctor' :
                            'Letter will be available once doctor approves the KYP'
                        ) : 'Letter will be available once KYP is generated by medical team'
                      ) :
                        letter.id === 'approval' ? 'Letter will be available once all verifications are completed' :
                          letter.id === 'disbursal' ? 'Letter will be available once application is approved' :
                            'Letter will be available once case is closed'}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Generated Documents History */}
        {sanctions.length > 0 && (
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Document History</h3>

            <div className="space-y-3">
              {sanctions.map((sanction) => (
                <div key={sanction.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                  <div className="flex items-center space-x-3">
                    <FileText className="h-5 w-5 text-gray-600" />
                    <div>
                      <p className="font-medium text-gray-900">{sanction.title}</p>
                      <p className="text-sm text-gray-600">
                        Generated by {sanction.generatedBy} on {formatDate(sanction.generatedAt)}
                      </p>
                      {sanction.hospitalAcknowledgement && (
                        <p className="text-xs mt-1">Acknowledgement: <span className={`${sanction.hospitalAcknowledgement.status === 'accepted' ? 'text-green-700' : sanction.hospitalAcknowledgement.status === 'challenged' ? 'text-orange-700' : 'text-gray-700'}`}>{(sanction.hospitalAcknowledgement.status || 'pending').toUpperCase()}</span>{sanction.hospitalAcknowledgement.comment ? ` • ${sanction.hospitalAcknowledgement.comment}` : ''}</p>
                      )}
                    </div>
                  </div>

                  <div className="flex items-center space-x-2">
                    <button
                      onClick={() => openLetter(sanction)}
                      className="text-blue-600 hover:text-blue-800"
                      title="View Letter"
                    >
                      <Eye className="h-4 w-4" />
                    </button>
                    <button
                      onClick={() => handleLetterDownload(sanction)}
                      disabled={(sanction.hospitalAcknowledgement?.status !== 'accepted')}
                      className={`${(sanction.hospitalAcknowledgement?.status !== 'accepted') ? 'text-gray-400 cursor-not-allowed' : 'text-green-600 hover:text-green-800'}`}
                      title="Download Letter"
                    >
                      <Download className="h-4 w-4" />
                    </button>
                    {sanction.hospitalAcknowledgement?.status !== 'accepted' && (
                      <>
                        <button
                          onClick={() => handleSanctionAcknowledgement(sanction, 'accepted')}
                          disabled={ackActionLoading[sanction.id] || sanction.hospitalAcknowledgement?.status === 'challenged'}
                          className="text-xs bg-green-600 text-white px-2 py-1 rounded hover:bg-green-700 disabled:opacity-50"
                        >
                          Accept
                        </button>
                        <button
                          onClick={() => openChallengeModal('sanction', sanction)}
                          disabled={ackActionLoading[sanction.id]}
                          className="text-xs bg-orange-600 text-white px-2 py-1 rounded hover:bg-orange-700 disabled:opacity-50"
                        >
                          Challenge
                        </button>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Challenge Comment Modal */}
        {showChallengeModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
              <h4 className="text-lg font-semibold text-gray-900 mb-2">Add Comments</h4>
              <p className="text-sm text-gray-600 mb-3">Please add your comments for challenging the {challengeContext.type === 'kyp' ? 'KYP' : 'letter'}.</p>
              <textarea value={challengeComment} onChange={(e) => setChallengeComment(e.target.value)} rows="4" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500" placeholder="Add your comments (optional)" />
              <div className="mt-4 flex justify-end gap-2">
                <button onClick={() => setShowChallengeModal(false)} className="px-3 py-2 border border-gray-300 rounded-lg">Cancel</button>
                <button onClick={submitChallenge} className="px-3 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700">Submit Challenge</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'details':
        return renderApplicationDetails();
      case 'documents':
        return renderDocuments();
      case 'discussions':
        return (
          <DiscussionComponent
            applicationId={applicationId}
            onUnreadCountChange={handleUnreadCountChange}
            disableQna={true}
          />
        );
      case 'disputes':
        return (
          <DisputeManager
            applicationId={applicationId}
            applicationData={application}
            onDisputeUpdate={loadApplicationData}
            onDisputeCountChange={handleDisputeCountChange}
            highlightDisputeId={highlightDisputeId}
          />
        );
      case 'status':
        return renderStatusTimeline();
      case 'sanctions':
        return renderSanctions();
      case 'discharge':
        return renderDischargeProcess();
      default:
        return renderApplicationDetails();
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-4">
            <div className="flex items-center space-x-4">
              <button
                onClick={() => navigate(-1)}
                className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors flex items-center space-x-2"
              >
                <ArrowLeft className="h-4 w-4" />
                <span>Back</span>
              </button>

              <div>
                <h1 className="text-2xl font-bold text-gray-900">Application Details</h1>
                <div className="flex items-center space-x-4 text-sm text-gray-600">
                  <span>ID: {application.applicationId}</span>
                  <span>•</span>
                  <span>Patient: {application.patient?.name}</span>
                  <span>•</span>
                  <span>Submitted: {formatDate(application.submittedAt)}</span>
                </div>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              {/* Global Search Bar */}
              <div className="w-80 hidden lg:block">
                <GlobalSearchBar userRole="hospital" />
              </div>

              <span className={`px-3 py-1 rounded-full text-sm font-medium border ${getStatusColor(application.status)}`}>
                {application.status?.replace('_', ' ').charAt(0).toUpperCase() + application.status?.replace('_', ' ').slice(1)}
              </span>

              {application.priority && application.priority !== 'normal' && (
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${application.priority === 'urgent'
                    ? 'bg-red-100 text-red-800'
                    : 'bg-yellow-100 text-yellow-800'
                  }`}>
                  {application.priority.charAt(0).toUpperCase() + application.priority.slice(1)}
                </span>
              )}

              {application.emergency && (
                <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs font-medium flex items-center space-x-1">
                  <AlertTriangle className="h-3 w-3" />
                  <span>Emergency</span>
                </span>
              )}

              {/* NEW: Treatment Plan indicator */}
              {application.treatmentPlanned === 'emergency' && (
                <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs font-medium">
                  Emergency Treatment
                </span>
              )}
            </div>
          </div>
          {(application?.workflow?.medicalVerification?.status === 'approved' ||
            application?.workflow?.policyVerification?.status === 'approved' ||
            !!application?.workflow?.dischargeSettlement?.finalApprovalLetterUrl ||
            (typeof application?.status === 'string' && application.status.includes('approved'))
          ) && (
              <div className="mt-2 mb-2 rounded-md border border-green-200 bg-green-50 text-green-800 text-sm px-3 py-2 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4 mr-2"><path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-2.59a.75.75 0 1 0-1.22-.86l-3.22 4.58-1.71-1.71a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.09l3.58-5.19Z" clipRule="evenodd" /></svg>
                Approved
              </div>
            )}
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white border-b border-gray-200">
        <div className="px-4 sm:px-6 lg:px-8">
          <nav className="flex space-x-8">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;

              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center space-x-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${isActive
                      ? 'border-teal-500 text-teal-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                >
                  <Icon className="h-4 w-4" />
                  <span>{tab.label}</span>
                  {tab.count !== null && tab.count > 0 && (
                    <span className="bg-teal-100 text-teal-800 text-xs font-medium px-2 py-0.5 rounded-full">
                      {tab.count}
                    </span>
                  )}
                </button>
              );
            })}
          </nav>
        </div>
      </div>

      {/* Tab Content */}
      <div className="px-4 sm:px-6 lg:px-8 py-8">
        {renderTabContent()}
      </div>

      {/* Document Viewer Modal */}
      {showDocumentModal && selectedDocument && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-4xl w-full h-5/6 flex flex-col">
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Document Viewer</h3>
                <p className="text-sm text-gray-600">{selectedDocument.fileName}</p>
              </div>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => downloadFile(selectedDocument.url, selectedDocument.fileName)}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 flex items-center space-x-2"
                >
                  <Download className="h-4 w-4" />
                  <span>Download</span>
                </button>
                <button
                  onClick={() => setShowDocumentModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>
            </div>

            <div className="flex-1 p-4">
              {selectedDocument.fileName.toLowerCase().endsWith('.pdf') ? (
                <iframe
                  src={selectedDocument.url}
                  className="w-full h-full border border-gray-300 rounded"
                  title="Document Viewer"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded">
                  <img
                    src={selectedDocument.url}
                    alt={selectedDocument.fileName}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}



      {/* Letter Viewer Modal */}
      {showLetterModal && selectedLetter && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-4xl w-full h-5/6 flex flex-col">
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Letter Viewer</h3>
                <p className="text-sm text-gray-600">{selectedLetter.title}</p>
                {selectedLetter.hospitalAcknowledgement && (
                  <p className="text-xs mt-1">Acknowledgement: <span className={`${selectedLetter.hospitalAcknowledgement.status === 'accepted' ? 'text-green-700' : selectedLetter.hospitalAcknowledgement.status === 'challenged' ? 'text-orange-700' : 'text-gray-700'}`}>{(selectedLetter.hospitalAcknowledgement.status || 'pending').toUpperCase()}</span>{selectedLetter.hospitalAcknowledgement.comment ? ` • ${selectedLetter.hospitalAcknowledgement.comment}` : ''}</p>
                )}
              </div>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => handleLetterDownload(selectedLetter)}
                  disabled={selectedLetter.hospitalAcknowledgement && selectedLetter.hospitalAcknowledgement.status !== 'accepted'}
                  className={`px-4 py-2 border rounded-lg flex items-center space-x-2 ${selectedLetter.hospitalAcknowledgement && selectedLetter.hospitalAcknowledgement.status !== 'accepted' ? 'border-gray-200 text-gray-400 cursor-not-allowed' : 'border-gray-300 text-gray-700 hover:bg-gray-50'}`}
                >
                  <Download className="h-4 w-4" />
                  <span>Download</span>
                </button>
                <button
                  onClick={() => setShowLetterModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>
            </div>

            <div className="flex-1 p-4">
              {selectedLetter.isKYPLetter ? (
                <div className="flex flex-col items-center justify-center h-full text-center">
                  <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
                    <h4 className="text-lg font-semibold text-blue-900 mb-2">KYP Letter Preview</h4>
                    <p className="text-blue-700 mb-4">
                      KYP letters are generated dynamically. Click the View button to open in a new tab or Download to save the PDF.
                    </p>
                    <div className="flex space-x-3">
                      <button
                        onClick={() => {
                          setShowLetterModal(false);
                          handleKYPPreview(selectedLetter);
                        }}
                        className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                      >
                        Open in New Tab
                      </button>
                      <button
                        onClick={() => handleLetterDownload(selectedLetter)}
                        disabled={(getKYPAck()?.status || 'pending') !== 'accepted'}
                        className={`px-4 py-2 rounded-lg text-white ${(getKYPAck()?.status || 'pending') !== 'accepted'
                            ? 'bg-gray-400 cursor-not-allowed'
                            : 'bg-gray-600 hover:bg-gray-700'
                          }`}
                      >
                        Download PDF
                      </button>
                    </div>
                    {(getKYPAck()?.status || 'pending') !== 'accepted' && (
                      <p className="text-xs text-gray-600 mt-2">Download will be enabled after hospital acknowledges the KYP.</p>
                    )}
                  </div>
                </div>
              ) : (
                <iframe
                  src={selectedLetter.url}
                  className="w-full h-full border border-gray-300 rounded"
                  title="Letter Viewer"
                />
              )}
            </div>
          </div>
        </div>
      )}

      {/* Review Confirmation Modal */}
      {showReviewConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg w-full max-w-xl">
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
              <h3 className="text-lg font-semibold text-gray-900">Confirm Send for Doctor Review</h3>
              <button onClick={() => setShowReviewConfirm(false)} className="text-gray-400 hover:text-gray-600">
                <X className="h-6 w-6" />
              </button>
            </div>
            <div className="p-4 space-y-4">
              <p className="text-sm text-gray-700">Please review the list of documents. You can proceed even if some are not uploaded.</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="border rounded-md">
                  <div className="px-3 py-2 bg-green-50 border-b text-sm font-semibold text-green-800">Submitted</div>
                  <ul className="max-h-56 overflow-auto p-3 list-disc list-inside text-sm text-gray-800">
                    {submittedTypes.length > 0 ? submittedTypes.map((t) => (<li key={t}>{t}</li>)) : (<li className="text-gray-500">None</li>)}
                  </ul>
                </div>
                <div className="border rounded-md">
                  <div className="px-3 py-2 bg-yellow-50 border-b text-sm font-semibold text-yellow-800">Not Submitted</div>
                  <ul className="max-h-56 overflow-auto p-3 list-disc list-inside text-sm text-gray-800">
                    {missingTypes.length > 0 ? missingTypes.map((t) => (<li key={t}>{t}</li>)) : (<li className="text-gray-500">None</li>)}
                  </ul>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <div className="flex-1 mr-3">
                  <input
                    type="text"
                    value={reviewNote}
                    onChange={(e) => setReviewNote(e.target.value)}
                    placeholder="Add note for doctor (optional)"
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
                  />
                </div>
                <div className="flex items-center gap-2">
                  <button onClick={() => setShowReviewConfirm(false)} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700">Cancel</button>
                  <button
                    onClick={async () => { setShowReviewConfirm(false); await sendDispatchForReview(); }}
                    disabled={reviewRequesting}
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
                  >
                    {reviewRequesting ? 'Sending…' : 'Proceed'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* KYP Preview Modal (unified at root) */}
      <KYPPreviewModal
        isOpen={showKYPPreview}
        onClose={() => setShowKYPPreview(false)}
        application={application}
        kypData={kypPreviewData?.kypData}
        canDownload={(getKYPAck()?.status || 'pending') === 'accepted'}
      />

      {/* FAL Preview Modal */}
      <FALPreviewModal
        isOpen={showFALPreview}
        onClose={() => setShowFALPreview(false)}
        application={application}
        remarks={application?.workflow?.dischargeSettlement?.comments || ''}
        canDownload={true}
        template="comprehensive"
      />

      {/* Document Query Details Modal */}
      {queryDetailsModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[80vh] overflow-hidden">
            <div className="p-6 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="bg-orange-100 p-2 rounded-lg">
                    <MessageCircle className="h-5 w-5 text-orange-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">Document Queries</h3>
                    <p className="text-sm text-gray-600">
                      {queryDetailsModal.docKey?.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => {
                    setQueryDetailsModal(null);
                    setReplyText('');
                    setReplyingToQuery(null);
                    setQueryDocFile(null);
                  }}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>
            </div>

            <div className="p-6 space-y-4 overflow-y-auto max-h-[calc(80vh-180px)]">
              {queryDetailsModal.queries.map((query) => (
                <div key={query.id} className="border border-gray-200 rounded-lg p-4">
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex-1">
                      <div className="flex items-center space-x-2 mb-2">
                        <span className="font-medium text-gray-900">{query.raisedBy?.name}</span>
                        <span className="text-xs text-gray-500">({query.raisedBy?.team})</span>
                        <span className={`text-xs px-2 py-0.5 rounded-full ${
                          query.status === 'open' ? 'bg-yellow-100 text-yellow-800' : 'bg-green-100 text-green-800'
                        }`}>
                          {query.status}
                        </span>
                      </div>
                      <p className="text-sm text-gray-700 mb-2">{query.comment}</p>
                      <p className="text-xs text-gray-500">
                        {query.raisedAt?.toDate ? query.raisedAt.toDate().toLocaleString() : 'Recently'}
                      </p>
                    </div>
                  </div>

                  {/* Replies */}
                  {query.replies && query.replies.length > 0 && (
                    <div className="mt-3 space-y-2 pl-4 border-l-2 border-gray-200">
                      {query.replies.map((reply, idx) => (
                        <div key={idx} className="bg-gray-50 p-3 rounded">
                          <div className="flex items-center space-x-2 mb-1">
                            <span className="text-xs font-medium text-gray-900">{reply.userName}</span>
                            {reply.isHospital && <span className="text-xs text-blue-600">(You)</span>}
                          </div>
                          <p className="text-sm text-gray-700">{reply.message}</p>
                          <p className="text-xs text-gray-500 mt-1">
                            {reply.timestamp?.toDate ? reply.timestamp.toDate().toLocaleString() : 'Just now'}
                          </p>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Reply input for open queries */}
                  {query.status === 'open' && (
                    <div className="mt-3 space-y-2">
                      {replyingToQuery === query.id ? (
                        <>
                          <textarea
                            value={replyText}
                            onChange={(e) => setReplyText(e.target.value)}
                            placeholder="Type your reply..."
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                            rows={3}
                          />
                          <div className="flex items-center space-x-2">
                            <button
                              onClick={() => handleReplyToQuery(query.id)}
                              disabled={!replyText.trim() || actionLoading[`reply_${query.id}`]}
                              className="px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700 disabled:opacity-50 flex items-center space-x-1"
                            >
                              {actionLoading[`reply_${query.id}`] && <Loader className="h-3 w-3 animate-spin" />}
                              <span>Send Reply</span>
                            </button>
                            <button
                              onClick={() => {
                                setReplyingToQuery(null);
                                setReplyText('');
                              }}
                              className="px-3 py-1 border border-gray-300 text-gray-700 rounded text-sm hover:bg-gray-50"
                            >
                              Cancel
                            </button>
                          </div>
                        </>
                      ) : (
                        <button
                          onClick={() => setReplyingToQuery(query.id)}
                          className="text-sm text-blue-600 hover:text-blue-800 flex items-center space-x-1"
                        >
                          <Reply className="h-3 w-3" />
                          <span>Reply</span>
                        </button>
                      )}

                      {/* Resolve with updated document */}
                      <div className="border-t border-gray-200 pt-3 mt-3">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Resolve with Updated Document
                        </label>
                        <input
                          type="file"
                          onChange={(e) => setQueryDocFile(e.target.files?.[0] || null)}
                          className="w-full text-sm"
                        />
                        {queryDocFile && (
                          <div className="mt-2">
                            <button
                              onClick={() => handleResolveQuery(query.id)}
                              disabled={uploadingQueryDoc}
                              className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50 flex items-center space-x-2 text-sm"
                            >
                              {uploadingQueryDoc && <Loader className="h-4 w-4 animate-spin" />}
                              <span>Resolve Query & Upload</span>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Resolved info */}
                  {query.status === 'resolved' && (
                    <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded">
                      <p className="text-sm text-green-800">
                        <strong>Resolved</strong> by {query.resolvedBy?.name} on{' '}
                        {query.resolvedAt?.toDate ? query.resolvedAt.toDate().toLocaleString() : 'Recently'}
                      </p>
                      {query.updatedDocumentUrl && (
                        <a
                          href={query.updatedDocumentUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-sm text-blue-600 hover:text-blue-800 flex items-center space-x-1 mt-1"
                        >
                          <Eye className="h-3 w-3" />
                          <span>View Updated Document</span>
                        </a>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Discharge Process Modal */}
      {showDischargeModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-md w-full">
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
              <h3 className="text-lg font-semibold text-gray-900">Initiate Discharge Process</h3>
              <button
                onClick={() => setShowDischargeModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="p-6">
              <div className="mb-4">
                <p className="text-sm text-gray-600 mb-4">
                  This will initiate the discharge process for the patient. Once initiated, the application status will change to "Discharge Process" and the patient will be eligible for discharge counselling.
                </p>

                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4">
                  <div className="flex">
                    <AlertTriangle className="h-5 w-5 text-yellow-600 mr-2" />
                    <div>
                      <p className="text-sm font-medium text-yellow-800">Please confirm</p>
                      <p className="text-xs text-yellow-700">Make sure all KYP verifications are completed before proceeding.</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex space-x-3">
                <button
                  onClick={() => setShowDischargeModal(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  onClick={handleInitiateDischargeProcess}
                  disabled={processingDischarge}
                  className="flex-1 bg-orange-600 text-white px-4 py-2 rounded-lg hover:bg-orange-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
                >
                  {processingDischarge ? (
                    <>
                      <Loader className="h-4 w-4 animate-spin" />
                      <span>Processing...</span>
                    </>
                  ) : (
                    <>
                      <Activity className="h-4 w-4" />
                      <span>Initiate Process</span>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApplicationDetails;
